import Medicinal from "@/components/medicinal.vue";
import Prescription from "@/components/prescription.vue";
import Orderdetail from "@/components/orderdetail.vue";
import {ArrowDownBold, ArrowLeftBold, CopyDocument, Plus} from "@element-plus/icons-vue";
import {
    getMedicalOrderDetail,
    getMedicalOrderDetailForOneMore,
    listFuMedicine,
    listPharmacyConfig,
    getPrescriptionDetail,
    getPatientList,
    getDocPatientProfile,
    addFromDocClinic,
    addClinicPrescriptionBatch,
    updateMedicalOrderForDoc,
    getDicts,
    addPrescription,
    getPatientListByName,
    getTodayReservationList,
    getTodayReservationStat,
    getUnifiedClinicQueue,
    callReturnVisit,
    completeReturnVisit,
    saveDocPatientProfile,
    listPatientHisMedical,
    cancelOrder,
    deleteCaseOrder,
    clinicSqbOrderPay,
    clinicSqbQueryResult,
    transMedicalType,
} from '@/api'
import baseConfig from "@/api/config";
import {alertMsg, chackAlertMsg, message, errorMsg, getTodayDate, getCurrentDoctorId} from "@/assets/utils/common";
import {getSignDoctorName, updateMedicineUsageSign} from "@/assets/utils/medicineUsage";
import {ElMessageBox} from "element-plus";
import { pcaTextArr } from "element-china-area-data"
import {getDecoctionName, refreshDecoctionNameMap} from "@/assets/utils/decoction";
import {getMedicineConversionTargetType} from "@/assets/utils/medicineDosageForm";
import {startReservationAutoRefresh, stopReservationAutoRefresh} from "@/assets/utils/reservationRefresh";

const ORDER_ADD_SERVICE_DAYS = 10;
// 多药方一次最多生成的工单数量；后续扩容只需调整此配置
const MAX_PRESCRIPTION_ORDERS = 3;
const DOC_FEE_OPTIONS = buildDocFeeOptions();
const RESERVATION_STATUS_OPTIONS = [
    {key: '', label: '全部', color: 'all'},
    {key: '5', label: '待就诊', color: 'pending'},
    {key: '2', label: '已就诊', color: 'visited'},
    {key: '7', label: '已过号', color: 'overdue'},
    {key: 'return', label: '回诊', color: 'return'}
];

function buildDocFeeOptions() {
    const options = [0];
    for (let fee = 5; fee <= 100; fee += 5) {
        options.push(fee);
    }
    for (let fee = 110; fee <= 300; fee += 10) {
        options.push(fee);
    }
    return options;
}
function buildFeeOptions(maxFee, defaultFee) {
    const max = parseFloat(maxFee) || 0;
    const def = parseFloat(defaultFee) || 0;
    const options = [0];
    for (let fee = 5; fee <= max; fee += 5) {
        options.push(fee);
    }
    // 默认值和最大值按实际整数值直接加入选项（不按5步值取整），其余选项保持5步长
    [def, max].forEach(fee => {
        if (fee > 0 && !options.includes(fee)) {
            options.push(fee);
        }
    });
    options.sort((a, b) => a - b);
    return options;
}
function toNumber(value) {
    const numberValue = parseFloat(value);
    if (Number.isNaN(numberValue)) {
        return 0;
    }
    return numberValue.toFixed(2);
}
function formatPrice(value) {
    return toNumber(value).toFixed(2);
}

/**
 * pending 自动轮询窗口（秒）。与后端扫码支付锁的 TTL 对齐
 * （ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）：
 * 窗口不得大于锁的 TTL —— 窗口先到点而锁还在，会出现「页面已转待人工核查、
 * 收银员想重扫却被锁挡住」的自相矛盾状态。两处必须一起改。
 */
const PAY_PENDING_WINDOW_SECONDS = 600;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    components: {
        ArrowDownBold,
        CopyDocument,
        ArrowLeftBold,
        Plus,
        Medicinal, Prescription, Orderdetail
    },
    props: {
        qorderId: "",
        qeditOrder: "",
        qagain: ""
    },
    data() {
        return {
            pagename: 'clinictreat',
            orderId: null,
            pendingCaseOrder: false,
            reservationPatient: null,
            choosePreId: null, // 所选常用处方ID
            again: null,
            editOrder: null,
            isOneMoreOrder: false, // 是否再来一单
            isEditOrder: false, // 是否修改订单
            isCancelOrder: false, // 是否取消订单
            isExportOrder: false, // 是否打开处方笺
            index: 0,
            userInfo: null,
            patientCurrentPage: 1,
            patientPageNums: 40,
            patientQueryParams: {
                name: '',
            },
            queryBySearchBtn: false, // 是否通过搜索查询的
            patientList: [],
            patientActiveTab: 'today',
            reservationStatus: '5',
            reservationList: [],
            // 回诊不在预约单表内，来自统一队列接口，且不分页
            reservationReturnList: [],
            reservationLoading: false,
            reservationRefreshInFlight: false,
            reservationQuery: {cardPatientName: ''},
            reservationSearchTimer: null,
            reservationStats: RESERVATION_STATUS_OPTIONS.map(item => ({...item, count: 0})),
            reservationSelectedId: null,
            reservationRefreshTimer: null,
            reservationCurrentPage: 1,
            reservationPageSize: 40,
            reservationLastPage: false,
            reservationSelectionActive: false,
            patientCount: 20,
            patiantloading: false,
            loadDisabled: false,
            // 加载时的文本提示
            loadMoreStatus: "noMore",
            lastPage: false, // 是否是最后一页
            contentText: {
                contentdown: ' ',
                contentrefresh: '加载中',
                contentnomore: '没有更多数据了'
            },

            loading: false,
            queryParams: {
                name: '',
                reStatus: '',
            },
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            tableLoading: false,
            tableData: [],
            dateTime: '',
            tableHeight: 500,

            // 病历列表
            currentPageRecord: 1,
            pageNumsRecord: 5,
            totalCountRecord: 0,
            recordTableLoading: false,
            recordLoadDisabled: false,
            recordTotal: 0,
            recordlist: [],
            recordRequestId: 0, // 历史病历请求版本，防止旧患者的慢响应覆盖当前数据
            recordTableHeight: 500,
            queryRecordParams: {
                keyWords: null,
                dppId: null,
                docId: null
            },
            dictOrderStatus: 'sys_order_status',
            dictOrderStatusList: [],

            chooseDppId: "",
            prescriptionList: [],
            prescriptionCount: 20,
            patientInfoList: [],
            patientRange: [],
            patientSelectParams: {
                name: null
            },
            nameSelectConShow: false,
            medicalOrderShow: true,
            searchPatientName: null, // 搜索的患者姓名
            patientRegion: ['河南省', '郑州市', '二七区'],
            patientAddress: null,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },

            titleAlertClock: null,
            titleAlertCountdown: 15,
            titleAlertShow: false, // 提示信息
            patientDppId: null, // 患者管理跳转过来的病例的dppId
            medicinalChooseDrawer: false,
            prescriptionDialogVisible: false,
            choosePrescriptionItem: null,
            choosePrescriptionDialogVisible: false, // 导入处方
            openMedicinalDrawerAfterPrescriptionImport: false,
            direction: 'rtl',
            // 医嘱禁忌
            tabooList: ["忌烟酒", "忌辛辣刺激", "忌生冷", "忌油腻", "备孕禁服", "忌荤腥", "忌发物", "忌与西药同服", "感冒停服", "经期停服", "哺乳禁服", "怀孕禁服"],
            // 用法
            useWayList: ["饭前一小时", "饭后一小时", "晨起服用", "睡前服用", "空腹服用"],
            editpatient: false, // 是否可编辑患者信息(会诊单不可编辑)
            usepatient: false, // 是否可编辑患者信息(患者管理进入不可编辑)
            tencentCosUrl: baseConfig.tencentCosUrl,
            sameMedicineList: [],
            doMedicineList: [],
            docMedicineArray: [],
            medicineTotle: 0,
            medicineHeavy: 0,
            useAttention: [], // 禁忌
            medSingleCounPrice: 0, // 每剂药材费用
            orderMedicalCountPrice: 0, // 药材总费用
            medicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                conId: null,
                serialNo: null,
                orderId: null,
                orderKind: '0',
                docPrice: "0.00", //诊费
                mainSuit: null, // 主诉
                inspectionRecord: null, // 检查记录
                clinicalDiagnosis: null, // 诊断结果
                patientMedicalHistory: null, // 既往史
                patientOperationHistory: null, // 过敏史
                nowMedicalHistory: null, // 现病史
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '1', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/100ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
                deliverWay: '1', // 配送方式
                receivePersonName: "", // 收货人姓名
                receivePhone: "", // 收货人手机
                receiveProvince: "", // 收货人所在省
                receiveCity: "", // 收货人所在市
                receiveCountry: "", // 收货人所在区
                receiveAddress: "", // 收货详细地址
            },
            receiveRegion: ['河南省', '郑州市', '二七区'],
            isKeyanOrder: false, // 是否为科研单
            doctorInfo: {
                treatFeeRate: null,
                treatFeeMaxRate: null, // 病程管理费用设置比例的最大值（医生基础信息查询返回）
                clinicDocPrice: null,
                clinicDocPriceRate: null,
                clinicDocPriceWay: "0",
                docFreeOpen: "",
                medNewRule: null,
            },
            indexMedicine: '0',
            chooseFuliao: {
                medicineId: null,
                meName: null,
                price: null,
                meDesc: null,
                meCount: null,
                countPrice: null,
            },
            choosedFuliaoShow: false,
            chooseFuliaoList: [],
            fuliaoList: [],
            orderDetailDialogVisible: false,
            showOrderMedicineFuList: "",

            chooseTabooList: [],
            gao_rate_low: 50,
            gao_rate_high: 80,
            gao_heavy_low: 0,
            gao_heavy_high: 0,
            gao_line: '1000',
            shui_rate_low: 80,
            shui_rate_high: 90,
            shui_heavy_low: 0,
            shui_heavy_high: 0,
            shui_line: '500',
            preMedWay: 'replace', // 选择常用处方时，药材的添加方式（替换或追加）
            addPrescriptionModal: false, // 保存到处方模板弹出层显隐
            medicineViceNumPrice: '0.00',  // 饮片每剂加工费用
            medicineGaoPrice: '0.00', // 膏方每克加工费用
            medicineShuiPrice: '0.00', // 水丸每克加工费用
            medicineGaoStartPrice: '0.00', // 膏方加工费用（起做）
            medicineShuiStartPrice: '0.00', // 水丸加工费用（起做）
            editFuliaoType: '', // 编辑的辅料的形式（edit:编辑；add:新增）

            medProgram: {
                treatmentProgram: null, // 治疗项目
                checkProgram: null, // 检查项目
            },
            treatmentProgramList: [{
                id: "1",
                name: "小针刀",
                price: "80.00",
                isChoosed: false
            }, {
                id: "2",
                name: "针灸",
                price: "12.00",
                isChoosed: false
            }, {
                id: "3",
                name: "针灸2",
                price: "18.00",
                isChoosed: false
            }], // 治疗项目列表
            checkProgramList: [{
                id: "1",
                name: "X光",
                price: "280.00",
                isChoosed: false
            }, {
                id: "2",
                name: "核磁共振12",
                price: "412.00",
                isChoosed: false
            }, {
                id: "3",
                name: "核磁共振13",
                price: "412.00",
                isChoosed: false
            }], // 检查项目列表


            addDialogVisible: false,
            prescriptionInfo: {
                preName: "",
                instructions: "",
                docPrescriptionMedicineList: [],
                billingType: "0",
                isTop: '1'
            },
            foldOrExpandPatient: true,
            patientData: null, // 缓存中的患者相关信息
            newRuleOpen: false,
            transMedicineTypeData: {
                meType: null,
                medicineList: [],
            },
            medicineTypeConversionRequestId: 0,
            isMedicineTypeConverting: false,
            prescriptionDrafts: [],
            activePrescriptionIndex: 0,
            multiPrescriptionSubmitting: false,
            pendingMultiPrescription: false,
            multiPrescriptionIndex: 0,
            multiPrescriptionOrderIds: [],

            patientDialogVisible: false, // 病历预览弹窗
            isLoadingPatient: false, // 病历数据加载圈
            bingliOrderId: null,
            bingliInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            bingliMedicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                conId: null,
                serialNo: null,
                orderId: null,
                docPrice: "0.00", //诊费
                mainSuit: null, // 主诉
                inspectionRecord: null, // 检查记录
                clinicalDiagnosis: null, // 诊断结果
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientPhone: null, // 患者手机哈
                patientIdentity: null, // 患者身份证
                patientProvince: null, // 省市区
                patientCountry: null, // 省市区
                patientCity: null, // 省市区
                patientStreet: null, // 详细地址
                patientMedicalHistory: null, // 既往史
                patientOperationHistory: null, // 现病史
                isFirstVisit: "",
            },

            prescriptionPaperDialogVisible: false, // 处方笺预览弹窗
            isLoadingPrintData: false, // 处方笺数据加载圈
            printDate: null, // 打印日期
            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部处方笺', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: 'false', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部处方笺', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {
                }, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {
                }, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {
                }, // 开启打印前的回调事件
                openCallback() {
                }, // 调用打印之后的回调事件
                closeCallback() {
                }, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            printBingliInfoObj: {
                id: 'printBingliArea',
                popTitle: '知夏中医门诊部门诊病历', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: 'false', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部门诊病历', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {
                }, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {
                }, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {
                }, // 开启打印前的回调事件
                openCallback() {
                }, // 调用打印之后的回调事件
                closeCallback() {
                }, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            payCodeList: [], // 预览的支付码
            printMedicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                conId: null,
                serialNo: null,
                orderId: null,
                docPrice: "0.00", //诊费
                mainSuit: null, // 主诉
                inspectionRecord: null, // 检查记录
                clinicalDiagnosis: null, // 诊断结果
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '1', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/100ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            payState: "", // 支付结果三态：success / pending / failed
            payChannel: "", // 支付成功渠道：SQB / CASH / FREE
            payRequesting: false, // 支付请求进行中，防止重复扫码发起第二笔扣款
            querying: false, // 「重新查询」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            removeScanListener: null, // 用于存储移除扫码监听器的函数
            regionData: pcaTextArr,
            dailyFee: 0.00, // 诊后病程管理每天的服务费用
            maxFee: 0, // 诊后病程管理每天的最大的费用
            hadEditAdjustmentPrice: false, // 是否修改了诊后病程管理费用
            editAdjustmentPrice: false, // 诊后病程管理修状态
            preEditAdjustmentPrice: null, // 编辑前的病程管理费用（取消修改时回退使用）
            feeOptions: [0],// 诊后病程管理
            docFeeOptions: DOC_FEE_OPTIONS, // 诊金
            serviceDays: ORDER_ADD_SERVICE_DAYS, // 诊后病程管理服务天数
            selectedDiseaseFeeValue: 0,
            selectedDocFeeValue: 0,

        }
    },
    computed: {

        maxPrescriptionOrders() {
            return MAX_PRESCRIPTION_ORDERS;
        },// 诊后病程管理每日费用显示文本
        // 三态文案：pending 绝不能被渲染成失败，否则会诱导收费员重复扫码
        payResultText() {
            if (this.payState === 'success') {
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                // 窗口到点后转「待人工核查」：仍是「未确认」，绝不能说成失败
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        },        dailyFeeText() {
            const fee = parseFloat(this.dailyFee);
            if (isNaN(fee) || fee === 0) {
                return { prefix: '每日约', amount: '￥0.00' };
            }
            if (fee < 0.01) {
                return { prefix: '每日小于', amount: '￥0.01' };
            }
            return { prefix: '每日约', amount: '¥' + this.dailyFee };
        },
    },
    created() {
        refreshDecoctionNameMap();
        this.resetMedical();
        if (!this.prescriptionDrafts.length) {
            this.prescriptionDrafts = [this.createPrescriptionDraft()];
        }
        this.qryListPharmacyConfig(); // 查询配置信息

        this.queryBySearchBtn = false;
        this.patientList = [];
        this.queryPatiantList(); // 默认查询患者列表
        this.queryTodayReservations();

        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList = res.data.data;
        });
        this.orderId = this.$route.query.qorderId;
        this.again = this.$route.query.qagain;
        this.editOrder = this.$route.query.qeditOrder;

        this.userInfo = JSON.parse(window.sessionStorage.getItem("user") || '{}');
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo") || '{}');
        // 修复：增加空对象默认值，防止doctorInfo为null时后续访问报错
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.medicalOrder.docId = this.doctorInfo.doctorId;
            if (this.doctorInfo.medNewRule === "" || this.doctorInfo.medNewRule === null || this.doctorInfo.medNewRule === undefined) {
                this.doctorInfo.medNewRule = "0";
            }
            if (this.doctorInfo.medNewRule === "1") {
                this.newRuleOpen = true;
            } else {
                this.newRuleOpen = false
            }
            window.sessionStorage.removeItem("newRuleOpen");
            window.sessionStorage.setItem("newRuleOpen", this.newRuleOpen);
            if (this.doctorInfo.docFreeOpen === null || this.doctorInfo.docFreeOpen === undefined || this.doctorInfo.docFreeOpen === '') {
                this.isKeyanOrder = false;
            } else {
                if (this.doctorInfo.docFreeOpen === '0') {
                    this.isKeyanOrder = true;
                } else {
                    this.isKeyanOrder = false;
                }
            }
            if (this.doctorInfo.clinicDocPrice === null || this.doctorInfo.clinicDocPrice === undefined || this.doctorInfo.clinicDocPrice === '') {
                this.doctorInfo.clinicDocPrice = "0";
            }
            if (this.doctorInfo.clinicDocPriceRate === null || this.doctorInfo.clinicDocPriceRate === undefined || this.doctorInfo.clinicDocPriceRate === '') {
                this.doctorInfo.clinicDocPriceRate = "0";
            }

            // 诊后管理费用设置
            if (this.doctorInfo.clinicDocPriceRate === null || this.doctorInfo.clinicDocPriceRate === undefined || this.doctorInfo.clinicDocPriceRate === '') {
                this.doctorInfo.clinicDocPriceRate = "0";
            }

            console.log("this.doctorInfo.treatFeeRate >>>> " + this.doctorInfo.treatFeeRate);
            if (this.doctorInfo.treatFeeRate === null || this.doctorInfo.treatFeeRate === undefined || this.doctorInfo.treatFeeRate === '') {
                this.doctorInfo.treatFeeRate = 0;
            }
            // 病程管理费用设置比例的最大值（未配置时保持为空，最大值计算回退使用 treatFeeRate）
            if (this.doctorInfo.treatFeeMaxRate === undefined || this.doctorInfo.treatFeeMaxRate === '') {
                this.doctorInfo.treatFeeMaxRate = null;
            }
        }

        this.patientDppId = window.sessionStorage.getItem('patientDppId'); // 选择常用处方时，药材的添加方式（替换或追加）
        console.log(this.patientDppId);
        if (this.patientDppId !== "" && this.patientDppId !== null && this.patientDppId !== undefined) {
            // 病例管理跳转时事件可能早于本页挂载，先恢复患者上下文再主动查询历史病历
            this.dppId = this.patientDppId;
            this.chooseDppId = this.patientDppId;
            this.checkSessionStorage(this.patientDppId);
            this.recordTableLoading = false;
            this.recordLoadDisabled = false;
            this.currentPageRecord = 1;
            this.recordlist = [];
            this.getPatientHiMedicalOrderListBySearchBtn();
        }

        this.preMedWay = window.sessionStorage.getItem('addType'); // 选择常用处方时，药材的添加方式（替换或追加）
        let docAdvice = window.sessionStorage.getItem('docAdvice');
        if (docAdvice !== "" && docAdvice !== null && docAdvice !== undefined) {
            this.medicalOrder.docAdvice = docAdvice;
        }
        let billingType = window.sessionStorage.getItem('billingType');
        if (billingType !== "" && billingType !== null && billingType !== undefined) {
            this.medicalOrder.billingType = billingType;
            this.indexMedicine = billingType;
            this.afterChangeMedicineType();
        } else {
            window.sessionStorage.setItem("billingType", "0");
        }
        this.medicineList = JSON.parse(window.sessionStorage.getItem('medicineList'));
        this.choosePreId = window.sessionStorage.getItem('choosePreId');
        this.reservationPatient = JSON.parse(window.sessionStorage.getItem('reservationPatient'));
        console.log("this.reservationPatient >>>> " + this.reservationPatient);
        if (this.reservationPatient !== "" && this.reservationPatient !== null && this.reservationPatient !== undefined) {
            this.patientInfo.dppId = "";
            this.patientInfo.docId = this.reservationPatient.docId;
            this.patientInfo.name = this.reservationPatient.name;
            this.searchPatientName = this.reservationPatient.name;
            this.patientInfo.sex = this.reservationPatient.sex;
            this.patientInfo.age = this.reservationPatient.age;
            this.patientInfo.phoneNumber = this.reservationPatient.phoneNumber;
            this.patientInfo.identity = this.reservationPatient.identity;
        }

        console.log("this.orderId >>>> " + this.orderId);
        console.log("this.again >>>> " + this.again);
        console.log("this.editOrder >>>> " + this.editOrder);
        console.log("this.choosePreId >>>> " + this.choosePreId);
        if (this.again !== "" && this.again !== null && this.again !== undefined) {
            this.isOneMoreOrder = true;
            if (this.again === "0") {
                this.medicalOrder.oldOrderId = this.orderId;
                if (this.choosePreId !== null && this.choosePreId !== "") {
                    this.getPrescriptionInfo();
                    window.sessionStorage.removeItem('choosePreId');
                } else if (this.medicineList !== null && this.medicineList !== "") {
                    this.getMedicineList();
                } else {
                    this.getMedicalOrderDetailInfoForOneMore();
                }
            } else {
                this.medicalOrder.oldOrderId = "";
                if (this.choosePreId !== null && this.choosePreId !== "") {
                    this.getPrescriptionInfo();
                    window.sessionStorage.removeItem('choosePreId');
                } else {
                    this.getMedicineList();
                }
            }
        } else if (this.editOrder !== "" && this.editOrder !== null && this.editOrder !== undefined) {
            this.isEditOrder = true;
            console.log("this.isEditOrder >>>> " + this.isEditOrder);
            this.medicalOrder.oldOrderId = "";
            if (this.choosePreId !== null && this.choosePreId !== "") {
                this.getPrescriptionInfo();
                window.sessionStorage.removeItem('choosePreId');
            } else if (this.medicineList !== null && this.medicineList !== "") {
                this.getMedicineList();
            } else {
                this.getMedicalOrderDetailInfoForOneMore();
            }
        } else {
            this.isOneMoreOrder = false;
            this.medicalOrder.oldOrderId = "";
            if (this.choosePreId !== null && this.choosePreId !== "") {
                this.getPrescriptionInfo();
                window.sessionStorage.removeItem('choosePreId');
            } else {
                this.getMedicineList();
            }
        }
    },
    mounted() {
        this.initScanListener();
        startReservationAutoRefresh(this, () => this.queryTodayReservations(true, false, true));
        window.addEventListener('reservationPatientChanged', this.loadReservationPatient);
        window.addEventListener('patientMedicalRecordChanged', this.loadPatientMedicalRecord);
    },

    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        this.stopPayPendingWatch();
        stopReservationAutoRefresh(this);
        window.removeEventListener('reservationPatientChanged', this.loadReservationPatient);
        window.removeEventListener('patientMedicalRecordChanged', this.loadPatientMedicalRecord);
        // 如果存在移除监听器的函数，则调用它
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    watch: {
        'medicalOrder.billingType'() {
            this.syncActivePrescriptionSummary();
        },
        'medicalOrder.orderPrice'() {
            this.syncActivePrescriptionSummary();
        },
        'docMedicineArray': {
            deep: true,
            handler() {
                this.syncActivePrescriptionSummary();
            }
        },
        'medicalOrder.docPrice'() {
            this.syncActivePrescriptionSummary();
        },
        'medicalOrder.adjustmentPrice'() {
            this.syncActivePrescriptionSummary();
        },
        'medicalOrder.processingCosts'() {
            this.syncActivePrescriptionSummary();
        },
        'chooseFuliaoList': {
            deep: true,
            handler() {
                this.syncActivePrescriptionSummary();
            }
        }
    },
    methods: {

        // 接诊面板可能在当前开方页已打开，路由不会重新创建组件，需要主动同步预约患者信息
        loadReservationPatient() {
            const reservationPatient = JSON.parse(window.sessionStorage.getItem('reservationPatient') || 'null');
            if (!reservationPatient) {
                return;
            }
            this.reservationPatient = reservationPatient;
            this.patientInfo.dppId = '';
            this.patientInfo.docId = reservationPatient.docId;
            this.patientInfo.name = reservationPatient.name;
            this.searchPatientName = reservationPatient.name;
            this.patientInfo.sex = reservationPatient.sex;
            this.patientInfo.age = reservationPatient.age;
            this.patientInfo.phoneNumber = reservationPatient.phoneNumber;
            this.patientInfo.identity = reservationPatient.identity;
        },

        // 病例管理跳转到当前已挂载的开方页时，同步患者基本信息和病历数据
        loadPatientMedicalRecord(event) {
            const eventData = event && event.detail ? event.detail : {};
            const dppId = eventData.dppId || window.sessionStorage.getItem('patientDppId');
            if (!dppId) {
                return;
            }
            const patientData = JSON.parse(window.sessionStorage.getItem('patient_' + dppId) || 'null');
            const patientInfo = eventData.patientInfo || (patientData && patientData.patientInfo);
            if (!patientInfo) {
                return;
            }
            this.patientDppId = dppId;
            this.chooseDppId = dppId;
            this.dppId = dppId;
            this.patientInfo = {...this.patientInfo, ...patientInfo, dppId: dppId};
            this.searchPatientName = this.patientInfo.name;
            this.medicalOrder = (patientData && (patientData.medicalOrder || patientData.medicalRecord)) || this.medicalOrder;
            this.medicalOrder.dppId = dppId;
            this.medicalOrder.patientName = this.patientInfo.name;
            this.medicalOrder.patientSex = this.patientInfo.sex;
            this.medicalOrder.patientAge = this.patientInfo.age;
            this.medicalOrder.patientPhone = this.patientInfo.phoneNumber;
            this.medicalOrder.patientIdentity = this.patientInfo.identity;
            this.parseMedinalOrderDetail();
            this.recordRequestId++;
            this.currentPageRecord = 1;
            this.recordLoadDisabled = false;
            this.recordlist = [];
            this.getPatientHiMedicalOrderListBySearchBtn();
        },

        // 统一刷新药材超量签章信息（根据实际重量与限制阈值对比）
        refreshUsageSigns() {
            const doctorName = getSignDoctorName();
            this.docMedicineArray.forEach(item => updateMedicineUsageSign(item, doctorName));
        },

        // 诊后病程管理费用默认值：按医生设置的比例值 treatFeeRate 计算
        getDefaultFee(medicineFee) {
            console.log("getDefaultFee  treatFeeRate >>>> " + this.doctorInfo.treatFeeRate);
            let treatFeeRateValue = toNumber(this.doctorInfo.treatFeeRate / 100)
            let defaultFee = toNumber(medicineFee) * treatFeeRateValue;
            return Math.floor(parseFloat(defaultFee));
        },

        // 诊后病程管理费用最大值：按医生配置的比例最大值 treatFeeMaxRate 计算；未配置时回退使用 treatFeeRate
        getMaxFee(medicineFee) {
            console.log("getMaxFee  treatFeeMaxRate >>>> " + this.doctorInfo.treatFeeMaxRate);
            let treatFeeRate = this.doctorInfo.treatFeeMaxRate;
            if (treatFeeRate === null || treatFeeRate === undefined || treatFeeRate === '') {
                treatFeeRate = this.doctorInfo.treatFeeRate;
            }
            let treatFeeRateValue = toNumber(treatFeeRate / 100)
            let maxFee = toNumber(medicineFee) * treatFeeRateValue;
            return Math.floor(parseFloat(maxFee));
        },

        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            console.log("orderId >>>>" + this.orderId);
            console.log("orderPrice >>>>" + this.printMedicalOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            // AC12：请求未返回前不允许再次扫码，否则并发扫码会发起第二笔扣款
            if (this.payRequesting) {
                console.warn("上一笔支付请求尚未返回，忽略本次扫码");
                return;
            }
            this.payRequesting = true;
            // 新一次扫码：结束上一轮 pending 窗口
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            this.payLoading = true;
            this.isPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            let params = {
                orderId: this.orderId,
                price: this.printMedicalOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            console.log("this.isWaitPayLoading >>>>" + this.isWaitPayLoading);
            console.log("this.payLoading >>>>" + this.payLoading);
            console.log("this.isPayed >>>>" + this.isPayed);
            clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                this.applyPayResult(response, false);
                // 支付完成后刷新订单状态
                this.recordlist = [];
                this.getPatientHiMedicalOrderListBySearchBtn();
            }).catch(error => {
                // AC13：请求异常一律回到「可重试」态，不能停留在等待扫码
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                this.payLoading = false;
                this.isWaitPayLoading = true;
                this.isPayed = false;
                this.payState = "";
                this.payChannel = "";
            }).finally(() => {
                this.payRequesting = false;
            });
        },

        // 统一落地后端三态契约：200+success / 601+pending / 其他=明确失败
        applyPayResult(response, silent) {
            const data = (response && response.data) || {};
            const payState = data.payState;
            const channel = data.channel;
            if (response && response.code === 200 && payState === 'success') {
                this.payState = 'success';
                this.payChannel = channel || '';
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payErrorMsg = "";
                message(this.paySuccessText(channel), "success");
            } else if (response && response.code === 601 && payState === 'pending') {
                // AC3：第三态。既不得显示成功，也不得显示失败。
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    // 首次进入 pending：开自动轮询窗口（与后端支付锁 TTL 对齐）
                    this.startPayPendingWatch();
                }
                this.payErrorMsg = this.payPendingExpired
                    ? this.pendingExpiredMessage()
                    : this.pendingMessage();
                if (!silent) {
                    message("支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = '';
                this.successPayed = false;
                this.payErrorMsg = (response && response.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
        },

        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // AC3：pending 态的「重新查询」，只读接口，绝不发起扣款
        requeryPayResult(silent) {
            if (this.querying) {
                return;
            }
            this.querying = true;
            clinicSqbQueryResult(this.orderId).then(response => {
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                this.applyPayResult(response, silent);
                this.recordlist = [];
                this.getPatientHiMedicalOrderListBySearchBtn();
            }).catch(error => {
                console.error('查询支付结果失败:', error);
                if (!silent) {
                    message("查询支付结果失败，请稍后重试", "error");
                }
            }).finally(() => {
                this.querying = false;
            });
        },

        /**
         * 开始 pending 自动轮询：每 PAY_PENDING_POLL_INTERVAL_SECONDS 秒查一次只读查单接口，
         * 最长 PAY_PENDING_WINDOW_SECONDS 秒；到点转「待人工核查」。
         *
         * 窗口到点后支付锁也随之过期，收银员可重新扫码 —— 重扫会先经后端
         * checkPreviousScanOrder：上一笔已 PAID 则直接报成功，仍是未定态则被保守拦截，
         * 因此「放行重扫」不会造成重复扣款。
         */
        startPayPendingWatch() {
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            this.payPendingTimer = setInterval(() => {
                // 状态已被其他路径改写（成功/失败/重置）时窗口自行结束，
                // 这样各处的重置逻辑不必逐个记得清定时器
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired();
                    return;
                }
                this.payErrorMsg = this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    // 自动轮询不弹 toast，避免每 10 秒打扰收银员一次
                    this.requeryPayResult(true);
                }
            }, 1000);
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        // 窗口到点：转「待人工核查」。绝不能说成「支付失败」—— 钱可能已经收了。
        markPayPendingExpired() {
            this.payPendingExpired = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + (PAY_PENDING_WINDOW_SECONDS / 60) + " 分钟仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为可编辑元素，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                const isEditable = target.tagName === 'INPUT' ||
                                  target.tagName === 'TEXTAREA' ||
                                  target.isContentEditable ||
                                  target.getAttribute('contenteditable') === 'true';
                if (isEditable) {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },


        getOrderStatus(dictCode) {
            return this.getDictValue(dictCode, this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },


        // 关闭患者列表
        foldOrExpandPatientList() {
            this.foldOrExpandPatient = !this.foldOrExpandPatient;
        },

        switchPatientTab(tab) {
            this.patientActiveTab = tab;
            if (tab === 'today') {
                this.reservationCurrentPage = 1;
                this.reservationLastPage = false;
                this.reservationList = [];
                this.queryTodayReservations(true);
            }
        },

        switchReservationStatus(status) {
            this.reservationStatus = status;
            this.reservationCurrentPage = 1;
            this.reservationLastPage = false;
            this.reservationList = [];
            this.queryTodayReservations(true);
        },

        handleReservationSearchInput() {
            window.clearTimeout(this.reservationSearchTimer);
            this.reservationSearchTimer = window.setTimeout(() => {
                this.reservationCurrentPage = 1;
                this.reservationLastPage = false;
                this.reservationList = [];
                this.queryTodayReservations(false);
            }, 300);
        },

        loadMoreReservations() {
            if (this.reservationLoading || this.reservationLastPage) {
                return;
            }
            this.reservationCurrentPage++;
            this.queryTodayReservations(false, true);
        },

        queryTodayReservations(refreshStats = true, append = false, silent = false) {
            // 上一轮自动刷新尚未返回时跳过本轮，避免请求堆积
            if (silent && this.reservationRefreshInFlight) return;
            // 静默刷新不打扰当前浏览位置，仅手动操作时重置分页
            if (refreshStats && !append && !silent) {
                this.reservationCurrentPage = 1;
                this.reservationLastPage = false;
            }
            const doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo") || '{}');
            const baseParams = {
                schDate: getTodayDate(),
                doctorId: doctorInfo.doctorId || null,
                cardPatientName: this.reservationQuery.cardPatientName,
                cardIdentity: '',
                pageNum: this.reservationCurrentPage,
                pageSize: this.reservationPageSize
            };
            if (!silent) {
                this.reservationLoading = true;
            }
            this.reservationRefreshInFlight = true;
            const loadReservationList = () => {
                // 回诊列表随统计一并刷新（loadReturnVisits），这里只需按最新关键字重排
                if (this.reservationStatus === 'return') {
                    this.applyReturnVisits(this.reservationReturnList);
                    this.reservationLoading = false;
                    this.reservationRefreshInFlight = false;
                    return;
                }
                //queueOrder=1：预约单按排队号（签到/现场挂号顺序）排序，由后端完成
                getTodayReservationList({...baseParams, reStatus: this.reservationStatus, reStatusNot: '1,3,4', reStatusMini: "", queueOrder: '1'}).then(response => {
                    const data = response.data || {};
                    const rows = data.code === 200 ? (data.rows || []).map(item => this.normalizeReservation(item)) : [];
                    this.reservationLastPage = rows.length < this.reservationPageSize;
                    this.reservationList = append ? this.reservationList.concat(rows) : rows;
                    // this.reservationList.sort((a, b) => {
                    //     const signTime = String(a.signTime || a.reSignTime || '9999-12-31 23:59:59').localeCompare(String(b.signTime || b.reSignTime || '9999-12-31 23:59:59'));
                    //     return signTime || String(a.reTime || '').localeCompare(String(b.reTime || ''));
                    // });
                }).catch(() => {
                    // 静默刷新失败保留现有列表，避免网络抖动清空面板
                    if (!silent) {
                        this.reservationList = [];
                    }
                }).finally(() => {
                    this.reservationLoading = false;
                    this.reservationRefreshInFlight = false;
                });
            };
            if (!refreshStats) {
                loadReservationList();
                return;
            }
            // 已通过"加载更多"翻页时，静默刷新只更新统计，不重置列表
            const statsOnly = silent && this.reservationCurrentPage > 1;
            // 单次聚合请求获取各状态统计
            const statRequest = getTodayReservationStat({schDate: baseParams.schDate, doctorId: baseParams.doctorId})
                .then(res => {
                    const rdata = res.data || {};
                    if (rdata.code === 200 && rdata.data) {
                        const d = rdata.data;
                        const statFieldMap = {'': 'total', '5': 'waitVisit', '2': 'done', '7': 'jumpCall'};
                        this.reservationStats.forEach(stat => {
                            const field = statFieldMap[stat.key];
                            if (field) stat.count = d[field] || 0;
                        });
                        // "全部"统计与列表口径一致：排除待支付/已失效/已取消（total 含全部状态，cancel=3+4，waitPay=1）
                        const totalStat = this.reservationStats.find(stat => stat.key === '');
                        if (totalStat) totalStat.count = (d.total || 0) - (d.cancel || 0) - (d.waitPay || 0);
                    }
                })
                .catch(() => {});
            // 回诊单独取统一队列，顺带刷新"回诊"计数
            const returnRequest = this.loadReturnVisits(silent);
            Promise.all([statRequest, returnRequest]).finally(() => {
                if (statsOnly) {
                    this.reservationRefreshInFlight = false;
                } else {
                    loadReservationList();
                }
            });
        },

        // 回诊列表：取统一队列里的回诊记录（WAITING/CALLED），与叫号面板同一数据源
        // 医生范围由后端按账号绑定关系决定，前端不传 doctorId
        loadReturnVisits(silent = false) {
            return getUnifiedClinicQueue({schDate: getTodayDate()}).then(response => {
                const data = response.data || {};
                const rows = data.code === 200 ? (data.data || []) : [];
                this.applyReturnVisits(rows.filter(item => item.queueType === 'RETURN').map(item => this.normalizeReturnVisit(item)));
            }).catch(() => {
                // 静默刷新失败保留现有回诊列表，避免网络抖动清空面板
                if (!silent) {
                    this.applyReturnVisits([]);
                }
            });
        },

        applyReturnVisits(rows) {
            this.reservationReturnList = rows || [];
            const returnStat = this.reservationStats.find(stat => stat.key === 'return');
            if (returnStat) returnStat.count = this.reservationReturnList.length;
            const keyword = (this.reservationQuery.cardPatientName || '').trim();
            const visible = keyword ? this.reservationReturnList.filter(item => (item.cardPatientName || '').indexOf(keyword) > -1) : this.reservationReturnList;
            if (this.reservationStatus === 'return') {
                this.reservationList = visible;
                // 回诊不分页，避免无限滚动继续拉预约单
                this.reservationLastPage = true;
            }
        },

        normalizeReservation(item) {
            const birthYear = item.cardPatientBirth ? new Date(item.cardPatientBirth).getFullYear() : null;
            return {...item, age: item.age === undefined || item.age === null ? (birthYear ? new Date().getFullYear() - birthYear : '--') : item.age};
        },

        // 统一队列的回诊条目转换为列表行，字段口径与预约行对齐
        normalizeReturnVisit(item) {
            const birthYear = item.cardPatientBirth ? new Date(item.cardPatientBirth).getFullYear() : null;
            return {
                ...item,
                isReturn: true,
                returnId: item.id,
                cardPatientName: item.patientName,
                cardPatientSex: item.cardPatientSex,
                cardPatientPhone: item.cardPatientPhone,
                cardIdentity: item.cardIdentity,
                age: birthYear ? new Date().getFullYear() - birthYear : '--'
            };
        },

        reservationStatusLabel(item) {
            if (item.isReturn) {
                return item.status === 'CALLED' ? '已接诊' : '待回诊';
            }
            const reservationStatusLabels = {
                '1': '待支付',
                '2': '已完成',
                '3': '已失效',
                '4': '已取消',
                '5': '待就诊',
                '6': '就诊中',
                '7': '已过号',
                '8': '待签到'
            };
            return reservationStatusLabels[String(item.reStatus)] || item.reStatusText || '未知';
        },

        reservationEmptyText() {
            const emptyTextMap = {
                '': '暂无今日预约人员',
                '5': '暂无待就诊人员',
                '2': '暂无已就诊人员',
                '7': '暂无已过号人员',
                'return': '暂无回诊人员'
            };
            return emptyTextMap[this.reservationStatus] || '暂无预约人员';
        },

        reservationStatusKey(item) {
            if (item.isReturn) {
                return item.status === 'CALLED' ? 'visited' : 'pending';
            }
            const status = RESERVATION_STATUS_OPTIONS.find(option => option.key === String(item.reStatus));
            return status ? status.color : 'other';
        },

        // 行文案：回诊用「回诊N号」，预约单用排队号（签到/现场挂号顺序），缺号存量单回退 re_no
        reservationRowLabel(item) {
            if (item.isReturn) {
                return (item.queueNoText || '') + (item.cardPatientName || '');
            }
            return ((item.queueSeq || item.reNo) || '') + '号' + (item.cardPatientName || '');
        },

        // 回诊行没有 reId，用 returnId 组成选中键，避免与预约单 id 撞号
        reservationRowKey(item) {
            return item.isReturn ? 'RV-' + item.returnId : 'R-' + item.reId;
        },

        isReservationSelected(item) {
            return this.reservationSelectedId === this.reservationRowKey(item) ||
                (item.dppId && this.chooseDppId === item.dppId);
        },

        reservationSex(sex) {
            return sex === '0' ? '男' : sex === '1' ? '女' : '未知';
        },

        chooseReservationPatient(item) {
            this.reservationSelectedId = this.reservationRowKey(item);
            this.reservationSelectionActive = true;
            // 修复：预约取号同样只匹配当前医生建的档案，避免关联到其他医生的dppId
            getPatientListByName({
                name: item.cardPatientName,
                identity: item.cardIdentity || '',
                docId: getCurrentDoctorId()
            }).then(response => {
                const rows = response.data && response.data.code === 200 ? response.data.rows || [] : [];
                const patient = rows.find(row => (item.cardIdentity && row.identity === item.cardIdentity) || (item.cardPatientPhone && row.phoneNumber === item.cardPatientPhone)) || rows[0];
                if (patient && patient.dppId) {
                    item.dppId = patient.dppId;
                    this.choosePatients(patient, true);
                } else {
                    this.fillReservationPatientInfo(item);
                }
            }).catch(() => {
                this.fillReservationPatientInfo(item);
            });
        },

        // 回诊接诊：置为已接诊并把患者带到开方区；已接诊的直接继续接诊
        acceptReturnVisit(item) {
            if (item.status === 'CALLED') {
                this.chooseReservationPatient(item);
                return;
            }
            callReturnVisit(item.returnId).then(res => {
                if (res.code === 200) {
                    item.status = 'CALLED';
                    message("已接诊 " + item.cardPatientName, "success");
                    this.chooseReservationPatient(item);
                    this.queryTodayReservations(true);
                } else {
                    message(res.msg || '回诊接诊失败', 'warning');
                }
            }).catch(error => {
                //失败必须出声：接口被拦或状态已变更时静默会导致“点了没反应”
                message(errorMsg(error, '回诊接诊失败'), 'error');
            });
        },

        // 回诊完成：状态置为 COMPLETED 后从回诊列表移除
        completeReturnVisitRow(item) {
            completeReturnVisit(item.returnId).then(res => {
                if (res.code === 200) {
                    message("已完成 " + item.cardPatientName + " 的回诊", "success");
                    this.queryTodayReservations(true);
                } else {
                    message(res.msg || '回诊完成失败', 'warning');
                }
            }).catch(error => {
                message(errorMsg(error, '回诊完成失败'), 'error');
            });
        },

        fillReservationPatientInfo(item) {
            this.chooseDppId = "";
            this.dppId = "";
            this.patientInfo.dppId = null;
            this.medicalOrder.dppId = null;
            this.recordRequestId++;
            this.recordlist = [];
            this.recordTotal = 0;
            this.patientInfo.name = item.cardPatientName;
            this.patientInfo.sex = item.cardPatientSex;
            this.patientInfo.age = item.age;
            this.patientInfo.phoneNumber = item.cardPatientPhone;
            this.patientInfo.identity = item.cardIdentity;
            this.searchPatientName = item.cardPatientName;
            this.medicalOrder.patientName = item.cardPatientName;
            this.medicalOrder.patientSex = item.cardPatientSex;
            this.medicalOrder.patientAge = item.age;
            this.medicalOrder.patientPhone = item.cardPatientPhone;
            this.medicalOrder.patientIdentity = item.cardIdentity;
        },

        // 保存为处方模版
        saveTemp() {
            this.addDialogVisible = true;
            this.prescriptionInfo.preName = "";
            this.prescriptionInfo.instructions = "";
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            // 修复：使用深拷贝避免引用共享问题
            this.prescriptionInfo.docPrescriptionMedicineList = JSON.parse(JSON.stringify(this.docMedicineArray));
        },

        // 确定保存为常用处方
        savePrescriptionFun() {
            if (this.prescriptionInfo.preName === null || this.prescriptionInfo.preName === "" || this.prescriptionInfo.preName === undefined) {
                message("处方模版名称不能为空", "error");
            } else if (this.prescriptionInfo.docPrescriptionMedicineList.length <= 0) {
                message("处方模版药品不能为空", "error");
            } else {
                addPrescription(this.prescriptionInfo).then(response => {
                    if (response.code === 200) {
                        message("保存为常用处方成功", "success");
                        this.addDialogVisible = false;
                    } else {
                        message("保存为常用处方失败", "error");
                    }
                });
            }

        },

        // 取消存为常用处方
        cancelPrescriptionFun() {
            this.prescriptionInfo.preName = "";
            this.prescriptionInfo.instructions = "";
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            this.prescriptionInfo.isTop = "1";
            this.addDialogVisible = false;
        },

        // 得到焦点选中 - 最完善版本
        focus(event) {
            console.log("event >>>>" + event);
            // 确保事件对象存在
            if (!event) return;
            // 获取目标元素
            const element = event.target || event.currentTarget;
            // 检查元素是否存在且支持 select 方法
            if (element && element.select && typeof element.select === 'function') {
                try {
                    element.select();
                } catch (error) {
                    console.warn('无法选中元素:', error);
                }
            } else {
                console.warn('目标元素不支持 select 方法:', element);
            }
        },

        // 输入框失焦处理 - 延迟隐藏下拉列表，避免点击选项时提前关闭
        handleInputBlur() {
            setTimeout(() => {
                this.nameSelectConShow = false;
            }, 200);
        },

        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.patientSelectParams.name = queryName;
                // 修复：/docPatientProfile/listAll 不会自动按医生过滤，必须显式传当前医生ID，否则会搜到其他医生的患者
                getPatientListByName({...this.patientSelectParams, docId: getCurrentDoctorId()}).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            // 搜索无结果，保留搜索词作为新患者姓名，不清空开方信息
                            this.nameSelectConShow = false;
                            // this.resetPatientPage2();  // 重置基本信息2（保留搜索词作为姓名）
                            // 注意：不再调用 resetMedicalOrder()，避免清空用户已编辑的处方信息
                        }
                    } else {
                        // API 异常时只隐藏下拉列表，不清空当前已选患者信息
                        this.nameSelectConShow = false;
                    }
                }).catch(() => {
                    // 请求失败时只隐藏下拉列表，不清空当前已选患者信息
                    this.nameSelectConShow = false;
                });
            } else {
                this.nameSelectConShow = false;
                // this.resetPatientPage();  // 重置基本信息
                // this.resetMedicalOrder(); // 重置开方页面
            }
        },


        // 确定选择患者
        sureChoosePatientInfo(dppId) {
            console.log("this.sureChoosePatientInfo dppId >>>>> " + dppId);
            this.patientInfoList.forEach(item => {
                if (dppId === item.dppId) {
                    this.searchPatientName = item.name;
                    this.patientInfo.name = this.searchPatientName;
                    console.log("this.searchPatientName >>>>> " + this.searchPatientName);
                    this.choosePatients(item);
                }
            })
            this.patientRange.forEach(itm => {
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
        },

        // 点击查询患者信息
        searchPatientList() {
            this.queryBySearchBtn = true;
            this.patientCurrentPage = 1;
            this.patientList = [];
            this.lastPage = false;
            this.loadDisabled = false;
            this.queryPatiantList();
        },

        // 获取近期患者列表
        queryPatiantList() {
            console.log(this.patientCurrentPage);
            if (this.patiantloading) {
                return;
            }
            this.patiantloading = true;
            this.patientQueryParams.pageNum = this.patientCurrentPage;
            this.patientQueryParams.pageSize = this.patientPageNums;
            getPatientList(this.patientQueryParams).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.loadMoreStatus = "more";
                    this.patientCount = response.data.total;
                    this.patiantloading = false;
                    // 将数据添加到列表中
                    console.log(response.data.rows.length);
                    if (response.data.rows.length > 0) {
                        if (response.data.rows.length < this.patientPageNums) {
                            this.lastPage = true;
                            this.loadDisabled = true;
                        }
                        this.patientList = this.patientList.concat(response.data.rows);
                    }
                    if (this.patientCurrentPage === 1 && this.queryBySearchBtn) {
                        this.choosePatients(this.patientList[0]);
                    }
                    if (this.patientList.length > 0) {
                        this.patientList.forEach((item) => {
                            if (item.sex === '0') {
                                item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else if (item.sex === '1') {
                                item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else {
                                item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            }).finally(() => {
                this.patiantloading = false;
            });
        },

        // 加载更多
        loadMorePatient() {
            if (this.lastPage || this.patiantloading) {
                this.loadMoreStatus = "noMore";
            } else {
                this.loadMoreStatus = "loading";
                // 将页码+1
                this.patientCurrentPage++;
                this.queryPatiantList();
            }

        },

        // 修改患者地址
        changePatientAddress() {
            console.log(this.patientRegion);
            this.patientInfo.province = this.patientRegion[0] + "-" + this.patientRegion[1] + "-" + this.patientRegion[2] + "-" + this.patientAddress;
            console.log(this.patientInfo.province)
        },

        // 重置（新患者）
        resetMedical() {
            // 修复：保存当前的dppId用于后续病历查询对比
            const previousDppId = this.dppId;

            this.resetPatientPage();  // 重置基本信息
            this.resetMedicalOrder(); // 重置开方页面

            this.recordTableLoading = false;
            this.recordLoadDisabled = false;
            this.currentPageRecord = 1;
            this.recordlist = [];

            // 注意：新增患者时dppId会被清空，这是合理的
            // 因为新患者在保存前还没有dppId
            // 保存成功后会在saveDocPateintProfileInfo中重新赋值
            console.log("新增患者，清空dppId，等待保存后重新赋值");
        },

        // 开方保存后仅清空药方，保留当前患者并刷新其历史病历
        refreshAfterMedicalOrderSave() {
            const currentDppId = this.dppId || this.patientInfo.dppId;

            this.dppId = currentDppId;
            this.chooseDppId = currentDppId;
            this.patientInfo.dppId = currentDppId;
            this.medicalOrder.dppId = currentDppId;
            this.resetMedicalOrder();

            this.recordTableLoading = false;
            this.recordLoadDisabled = false;
            this.currentPageRecord = 1;
            this.recordlist = [];
            this.getPatientHiMedicalOrderListBySearchBtn();
        },

        // 查询患者历史订单
        getPatientHiMedicalOrderdList() {
            console.log("this.queryRecordParams.keyWords");
            console.log(this.queryRecordParams.keyWords);
            this.recordTableLoading = false;
            this.recordLoadDisabled = false;
            this.currentPageRecord = 1;
            this.recordlist = [];
            this.getPatientHiMedicalOrderListBySearchBtn();
        },

        // 查询病历列表
        getPatientHiMedicalOrderListBySearchBtn() {
            const requestId = ++this.recordRequestId;
            const requestDppId = this.dppId;
            this.recordTotal = 0;
            // 修复：增加dppId有效性校验，防止查询到其他患者的病历
            if (!requestDppId || requestDppId === "" || requestDppId === null || requestDppId === undefined) {
                console.log("dppId为空，不查询病历列表");
                this.recordTableLoading = false;
                this.recordlist = [];
                return;
            }

            this.recordTableLoading = true;
            //根据工单类型筛选，已完成订单
            const params = {
                ...this.queryRecordParams,
                pageNum: this.currentPageRecord,
                pageSize: this.pageNumsRecord,
                dppId: parseInt(requestDppId)
            };
            console.log("查询病历列表, dppId:", requestDppId);
            listPatientHisMedical(params).then(response => {
                if (requestId !== this.recordRequestId || requestDppId !== this.dppId) {
                    return;
                }
                console.log(response);
                this.recordTableLoading = false;
                if (response.data.code === 200) {
                    this.recordTotal = response.data.total;
                    console.log(response.data.rows.length);
                    if (response.data.rows.length > 0) {
                        if (response.data.rows.length < this.pageNumsRecord) {
                            this.recordLoadDisabled = true;
                        }
                        let rows = this.dealyMedicine(response.data.rows);
                        this.recordlist = rows;
                    } else if (this.reservationSelectionActive && this.currentPageRecord === 1) {
                        this.$message.info('该预约人暂无历史病历，请按首次就诊信息填写');
                    }
                }
            });
        },

        // 加载更多
        loadMorePatientHiMedicalOrder() {
            console.log("this.recordLoadDisabled");
            console.log(this.recordLoadDisabled);
            if (!this.recordLoadDisabled) {
                this.currentPageRecord++; // 将页码+1
                this.getPatientHiMedicalOrderList();
            }

        },


        // 查询病历列表
        getPatientHiMedicalOrderList() {
            const requestId = ++this.recordRequestId;
            const requestDppId = this.dppId;
            // 修复：增加dppId有效性校验，防止查询到其他患者的病历
            if (!requestDppId || requestDppId === "" || requestDppId === null || requestDppId === undefined) {
                console.warn("dppId为空，不查询更多病历");
                this.recordTableLoading = false;
                return;
            }

            this.recordTableLoading = true;
            //根据工单类型筛选，已完成订单
            const params = {
                ...this.queryRecordParams,
                pageNum: this.currentPageRecord,
                pageSize: this.pageNumsRecord,
                dppId: parseInt(requestDppId)
            };
            console.log("加载更多病历, dppId:", requestDppId);
            listPatientHisMedical(params).then(response => {
                if (requestId !== this.recordRequestId || requestDppId !== this.dppId) {
                    return;
                }
                console.log(response);
                this.recordTableLoading = false;
                if (response.data.code === 200) {
                    this.recordTotal = response.data.total;
                    console.log(response.data.rows.length);
                    if (response.data.rows.length > 0) {
                        if (response.data.rows.length < this.pageNumsRecord) {
                            this.recordLoadDisabled = true;
                        }
                        let rows = this.dealyMedicine(response.data.rows);
                        this.recordlist = this.recordlist.concat(rows);
                    }
                }
            });
        },


        // 处理订单内的药材
        dealyMedicine(rows) {
            rows.forEach((item) => {
                if (item.orderMedicineList !== null) {
                    item.orderMedicineList.forEach(melist => {
                        let decoctWay = melist.decoctWay;
                        let decoctionName = getDecoctionName(decoctWay);
                        melist.decoctionName = decoctionName;
                        melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        if (item.orderMedicineList.billingType === "0") {
                            if (melist.newGCount === null) {
                                melist.newGCount = melist.countNum;
                            }
                            if (this.newRuleOpen) {
                                melist.countNum = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                            } else {
                                melist.countNum = melist.newGCount;
                            }
                        } else {
                            melist.newGCount = melist.countNum;
                        }
                    })
                }
            })
            return rows;
        },


        // 选择患者(优化版:智能缓存+轻量提示)
        choosePatients(itm, fromReservation = false) {
            console.log("choosePatients  itm >>>> ", itm);
            this.reservationSelectionActive = fromReservation;
            // 如果是同一个患者,直接返回
            if (this.chooseDppId === itm.dppId) {
                // 姓名筛选后再次选择当前患者时，仍需刷新历史病历
                this.dppId = itm.dppId;
                this.patientInfo.dppId = itm.dppId;
                this.medicalOrder.dppId = itm.dppId;
                this.recordTableLoading = false;
                this.recordLoadDisabled = false;
                this.currentPageRecord = 1;
                this.recordlist = [];
                this.getPatientHiMedicalOrderListBySearchBtn();
                return;
            }

            // 判断是否有未保存的开方内容
            const hasUnsavedContent = this.checkHasUnsavedMedicalOrder();

            if (hasUnsavedContent) {
                // 有未保存内容,自动缓存并显示轻提示,不阻塞操作
                console.log("检测到未保存的开方信息,自动缓存");
                let sessionData = {
                    "patientInfo": this.patientInfo,
                    "medicalOrder": this.medicalOrder
                };
                console.log("choosePatients  chooseDppId >>>> ", this.chooseDppId);
                window.sessionStorage.removeItem("patient_" + this.chooseDppId);
                window.sessionStorage.setItem("patient_" + this.chooseDppId, JSON.stringify(sessionData));

                // 使用轻量提示代替弹窗(2秒自动消失)
                this.$message({
                    message: `已自动缓存【${this.patientInfo.name}】的开方信息`,
                    type: 'info',
                    duration: 2000,
                    showClose: true
                });
            }

            // 执行患者切换(无论是否有缓存都继续)
            this.switchToPatient(itm);
        },

        // 检查是否有未保存的开方内容
        checkHasUnsavedMedicalOrder() {
            // 判断条件:患者已选择且有开方数据
            if (!this.chooseDppId || this.chooseDppId === "" || this.chooseDppId === null) {
                return false;
            }

            // 检查是否有诊断信息或药品信息
            const hasDiagnosis = this.medicalOrder.clinicalDiagnosis && this.medicalOrder.clinicalDiagnosis.trim() !== '';
            const hasMedicines = this.medicalOrder.orderMedicineList && this.medicalOrder.orderMedicineList.length > 0;
            const hasMainSuit = this.medicalOrder.mainSuit && this.medicalOrder.mainSuit.trim() !== '';

            return hasDiagnosis || hasMedicines || hasMainSuit;
        },

        // 执行患者切换(抽取公共逻辑)
        switchToPatient(itm) {
            this.chooseDppId = itm.dppId;
            this.dppId = itm.dppId;
            this.patientInfo.dppId = itm.dppId;
            this.medicalOrder.dppId = itm.dppId;
            this.searchPatientName = itm.name;
            this.patientInfo.name = this.searchPatientName;
            this.checkSessionStorage(itm.dppId);

            // 重置病历列表并加载新患者病历
            this.recordTableLoading = false;
            this.recordLoadDisabled = false;
            this.currentPageRecord = 1;
            this.recordlist = [];
            this.getPatientHiMedicalOrderListBySearchBtn();
            this.changeDeliverWayType();
        },


        // 判断缓存中是否存在当前患者基本信息
        checkSessionStorage(dppId) {
            console.log("checkSessionStorage  dppId >>>> ", dppId);
            this.titleAlertShow = false;
            this.titleAlertCountdown = 15;
            window.clearInterval(this.titleAlertClock);
            this.patientData = JSON.parse(window.sessionStorage.getItem("patient_" + dppId));
            console.log("checkSessionStorage  patientData >>>> ", this.patientData);
            if (this.patientData !== "" && this.patientData !== undefined && this.patientData !== null) {
                this.resetMedicalOrder(); // 重置开方页面
                this.titleAlertShow = true;
                this.titleAlertClock = window.setInterval(() => {
                    this.titleAlertCountdown--;
                    if (this.titleAlertCountdown <= 0) {
                        this.titleAlertShow = false;
                        window.clearInterval(this.titleAlertClock);
                    }
                }, 1000);
                console.log("继续编辑缓存病历和开方信息");
                this.patientInfo = this.patientData.patientInfo;
                this.medicalOrder = this.patientData.medicalOrder || this.patientData.medicalRecord;
                this.parseMedinalOrderDetail(); // 订单详情分析

                this.searchPatientName = this.patientInfo.name;
                // 将患者信息同步至药方的患者信息字段
                this.medicalOrder.patientPhone = this.patientInfo.phoneNumber;
                this.medicalOrder.patientName = this.patientInfo.name;
                this.medicalOrder.patientSex = this.patientInfo.sex;
                this.medicalOrder.patientAge = this.patientInfo.age;
                this.medicalOrder.patientIdentity = this.patientInfo.identity;
                this.medicalOrder.dppId = dppId;
            } else {
                this.openPatientDetail(dppId);
                this.resetMedicalOrder(); // 重置开方页面
                // 注意：重置开方页面已在 choosePatients 中统一处理
                // 这里只负责获取患者详情
            }
        },

        // 关闭弹窗
        closeTitleAlert() {
            this.titleAlertShow = false;
        },

        // 重新编辑
        againMedicalOrder(dppId) {
            window.sessionStorage.removeItem("patient_" + dppId)
            this.openPatientDetail(dppId);
            this.resetMedicalOrder(); // 重置开方页面
        },

        // 查看详情
        openPatientDetail(dppId) {
            this.dppId = dppId;
            this.qryPatientDetailInfo();// 查询患者详情
        },


        // 查询详情
        qryPatientDetailInfo() {
            let data = {};
            getDocPatientProfile(this.dppId, data).then(response => {
                // console.log(response);
                if (response.data.code === 200) {
                    if (response.data.data !== null && response.data.data !== undefined) {
                        this.patientInfo = response.data.data;
                        this.casePic = this.patientInfo.casePic;
                        if (this.casePic !== null && this.casePic !== "" && this.casePic !== undefined) {
                            let casePicArr = this.casePic.split(",");
                            // console.log(casePicArr)
                            if (casePicArr.length > 0) {
                                this.casePicArray = [];
                                this.confileLists = [];
                                for (let i = 0; i < casePicArr.length; i++) {
                                    let casePicUrl = this.tencentCosUrl + casePicArr[i];
                                    // console.log("casePicUrl:"+casePicUrl)
                                    this.casePicArray.push(casePicUrl);
                                    var imageUrl = {"url": casePicUrl};
                                    this.confileLists.push(imageUrl);
                                }

                            } else {
                                this.casePicArray = [];
                                this.confileLists = [];
                            }
                        } else {
                            this.casePicArray = [];
                            this.confileLists = [];
                        }
                        // console.log("this.patientInfo.sex")
                        // console.log(this.patientInfo.sex)
                        if (this.patientInfo.sex === "1") {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else if (this.patientInfo.sex === "0") {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                        if (this.patientInfo.province !== null && this.patientInfo.province !== "" && this.patientInfo.province !== undefined) {
                            let regionData = this.patientInfo.province.split("-");
                            this.patientRegion = [regionData[0], regionData[1], regionData[2]];
                            this.patientAddress = regionData[3];
                        } else {
                            this.patientRegion = ['河南省', '郑州市', '二七区'];
                            this.patientAddress = "";
                        }
                    } else {
                        this.casePicArray = [];
                        this.confileLists = [];
                    }
                }
            })
        },

        // 对患者诊断信息进行展开或收缩操作
        changeMedicalOrderShow() {
            this.medicalOrderShow = !this.medicalOrderShow;
        },

        // 患者手机号输入后正则校验
        changePatientPhoneNumber() {
            var mobilePattern = /^1[3456789]\d{9}$/;
            if (!mobilePattern.test(this.patientInfo.phoneNumber)) {
                message("手机号码格式不正确！", "error");
            }
        },


        // 患者身份证信息输入后计算年龄
        changePatientIdentity() {
            let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            if (this.patientInfo.identity.length !== 18 && this.patientInfo.identity.length !== 15) {
                message("身份证号码长度错误", "error");
                return; // 修复：添加return阻止继续执行
            } else if (!_IDRe18.test(this.patientInfo.identity) && !_IDre15.test(this.patientInfo.identity)) {
                message("身份证号码格式不正确！", "error")
                return; // 修复：添加return阻止继续执行
            } else {
                let year;
                if (this.patientInfo.identity.length === 18) {
                    year = this.patientInfo.identity.substring(6).substring(0, 4);// 得到年份
                } else {
                    year = "19" + this.patientInfo.identity.substring(6, 8);// 年份
                }
                let nowYear = new Date().getFullYear();
                let age = parseInt(nowYear) - parseInt(year);
                // 修复：处理负数年龄情况（未来日期）
                if (age < 0 || age > 150) {
                    message("身份证号码中的日期不合理！", "error");
                    return;
                }
                console.log("age = " + age);
                this.patientInfo.age = age;
            }
        },


        // 重置患者信息页面
        resetPatientPage() {
            this.chooseDppId = "";
            this.dppId = "";
            this.searchPatientName = null;
            this.patientInfo.name = null;
            this.patientInfo.sex = null;
            this.patientInfo.phoneNumber = null;
            this.patientInfo.identity = null;
            this.patientRegion = ['河南省', '郑州市', '二七区'];
            this.patientAddress = "";
            this.patientInfo.bloodType = null;
            this.patientInfo.allergyHistory = null; // 过敏史
            // 重置后需要重新关联医生ID
            if (this.doctorInfo && this.doctorInfo.doctorId) {
                this.patientInfo.docId = this.doctorInfo.doctorId;
            }
        },

        // 重置患者信息页面2
        resetPatientPage2() {
            this.chooseDppId = "";
            this.dppId = "";
            this.searchPatientName = this.searchPatientName || null; // 保留搜索词作为新患者姓名
            this.patientInfo.name = this.searchPatientName;
            this.patientInfo.sex = null;
            this.patientInfo.phoneNumber = null;
            this.patientInfo.identity = null;
            this.patientInfo.province = null;
            this.patientInfo.bloodType = null;
            this.patientInfo.allergyHistory = null; // 过敏史
            // 重置后需要重新关联医生ID
            if (this.doctorInfo && this.doctorInfo.doctorId) {
                this.patientInfo.docId = this.doctorInfo.doctorId;
            }
        },

        // 重置开方页面
        resetMedicalOrder() {
            window.sessionStorage.removeItem("choosePreId");
            window.sessionStorage.removeItem('preId');
            window.sessionStorage.removeItem('docAdvice');
            window.sessionStorage.removeItem('billingType');
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.removeItem("viceNum");
            this.resetMedicalOrderFrom(); // 重置开方信息
        },

        // 重置开方信息
        resetMedicalOrderFrom(preserveSharedMedicalInfo = false) {
            this.docMedicineArray = [];
            this.indexMedicine = "0";

            if (!preserveSharedMedicalInfo) {
                this.medicalOrder.mainSuit = null; //主诉
                this.medicalOrder.inspectionRecord = null; //检查记录
                this.medicalOrder.clinicalDiagnosis = null; //诊断结果
                this.medicalOrder.patientMedicalHistory = null; // 既往史
                this.medicalOrder.nowMedicalHistory = null; // 现病史
                this.medicalOrder.patientOperationHistory = null; // 过敏史
            }
            this.medicalOrder.docPrice = "0.00"; //诊费
            this.medicalOrder.medicineType = "0"; //药剂类型
            this.medicalOrder.orderKind = '0';
            this.medicalOrder.billingType = '0'; // 开单类型(0=颗粒;1=饮片;2=膏方;3=水丸)
            this.medicalOrder.orderMedicineList = []; // 关联药品
            this.medicalOrder.remark = null; //备注
            this.medicalOrder.oldOrderId = null;
            this.medicalOrder.hasLinkDoctor = false;
            this.medicalOrder.takeWay = "0";
            this.medicalOrder.viceNum = "7"; //药品副数
            this.medicalOrder.docAdvice = '开水温服';
            this.medicalOrder.medicalCountPrice = "0.00"; //药材费用
            this.medicalOrder.processingCosts = "0.00"; //加工费用
            this.medicalOrder.orderPrice = "0.00"; //总价
            this.medicalOrder.instructions = null;
            this.medicalOrder.adjustmentPrice = "0.00";// 调理价格
            this.medicalOrder.discountPrice = "0.00"; // 优惠金额
            this.medicalOrder.freeCasePic = ""; // 科研药方的图片
            this.medicalOrder.isFree = "1";
            this.medicalOrder.dayTakeNum = "1"; //X日一剂
            this.medicalOrder.takeTimes = "2"; // 每日分X次服用/每日X次
            this.medicalOrder.timeUseNum = "1"; // 每次XX克、XX毫升
            this.medicalOrder.packWay = "0"; // 包装方式 （0袋装 1瓶装）
            this.medicalOrder.useWay = null; // 医嘱用法
            this.medicalOrder.useAttention = null; // 医嘱禁忌
            this.useAttention = []; // 医嘱禁忌
            this.medicalOrder.fuCountPrice = 0;  // 辅药药品费用
            this.medicalOrder.decoctType = '1'; // 煎煮方式  0=自煎;1=代煎
            this.medicalOrder.specification = '200'; // 煎煮规格 规格 200ml/100ml
            this.medicalOrder.orderMedicineFuList = [];  //辅药列表（和药品列表一样传参）
            window.sessionStorage.setItem("billingType", this.medicalOrder.billingType);
            this.afterChangeMedicineType();
        },


        // 打开订单详情
        openOrderDetail(orderId, status) {
            this.orderId = orderId;
            if (status === '1') {
                message("药方审核中，请耐心等待...", "error");
            } else if (status === '2') {
                message("药方转方中，请耐心等待...", "error");
            } else {
                this.orderDetailDialogVisible = true;
            }
        },

        // 打开处方笺
        exportOrder(orderId) {
            this.orderId = orderId;
            this.isExportOrder = true;
            this.prescriptionPaperDialogVisible = true;
            this.isLoadingPrintData = true;
            this.printDate = this.getDayDateNow();
            this.getPrintMedicalOrderDetailInfo();
        },

        // 取消打印处方笺
        cancelOrderPrint() {
            this.prescriptionPaperDialogVisible = false;
        },


        // 获取处方笺打印的订单详情
        getPrintMedicalOrderDetailInfo() {
            getMedicalOrderDetail(this.orderId).then(response => {
                console.log(response);
                this.isLoadingPrintData = false;
                // this.patientInfo = response.data.data.patientInfo;
                this.patientInfo = response.data.data.docPatientProfile;
                this.printMedicalOrder = response.data.data.medicalOrder;
                if (this.printMedicalOrder.docAdvice === null) {
                    this.printMedicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
                }
                if (this.printMedicalOrder.picUrl !== null && this.printMedicalOrder.picUrl !== "") {
                    this.printMedicalOrder.picUrl = this.tencentCosUrl + this.printMedicalOrder.picUrl;
                }
                this.payCodeList = [];
                this.payCodeList.push(this.tencentCosUrl + this.printMedicalOrder.payQrcode);
                if (this.printMedicalOrder.takeWay === "null" || this.printMedicalOrder.takeWay === null) {
                    this.printMedicalOrder.takeWay = "0";
                }
                if (this.printMedicalOrder.viceNum === null || this.printMedicalOrder.viceNum === undefined || this.printMedicalOrder.viceNum === "") {
                    this.printMedicalOrder.viceNum = "1";
                }
                this.printMedicalOrder.packWay = this.printMedicalOrder.packWay === null ? '0' : this.printMedicalOrder.packWay;
                if (this.printMedicalOrder.packWay === '0') {
                    this.printMedicalOrder.timeUseNum = '1';
                } else {
                    this.printMedicalOrder.timeUseNum = '10';
                }
                this.printMedicalOrder.dayTakeNum = this.printMedicalOrder.dayTakeNum === null ? '1' : this.printMedicalOrder.dayTakeNum;//X日一剂
                this.printMedicalOrder.takeTimes = this.printMedicalOrder.takeTimes === null ? '2' : this.printMedicalOrder.takeTimes;// 每日分X次服用/每日X次
                this.printMedicalOrder.timeUseNum = this.printMedicalOrder.timeUseNum === null ? '1' : this.printMedicalOrder.timeUseNum;// 每次XX克、XX毫升

                let printDocMedicineArray = [];
                var orderMedicineList = this.printMedicalOrder.orderMedicineList;
                console.log("orderMedicineList");
                console.log(orderMedicineList);
                if (orderMedicineList !== null) {
                    orderMedicineList.forEach(melist => {
                        let decoctWay = melist.decoctWay;
                        let decoctionName = getDecoctionName(decoctWay);
                        melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        if (this.printMedicalOrder.billingType === "0") {
                            if (melist.newGCount === null) {
                                melist.newGCount = melist.countNum;
                            }
                            if (this.newRuleOpen) {
                                melist.countNum = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                            } else {
                                melist.countNum = melist.newGCount;
                            }
                        } else {
                            melist.newGCount = melist.countNum;
                        }
                        let mCount = parseFloat(parseFloat(melist.countNum) * parseFloat(melist.price)).toFixed(2);
                        printDocMedicineArray.push({
                            medicineId: melist.medicineId,
                            meName: melist.meName,
                            price: melist.price,
                            gCount: melist.countNum,
                            newGCount: melist.newGCount,
                            newRatio: melist.newRatio,
                            standard: melist.standard,
                            meRemark: melist.meDesc,
                            mCount: mCount,
                            decoctionId: decoctWay,
                            decoctionName: decoctionName,
                            drugProperty: melist.drugProperty
                        });
                    })
                }

                this.showOrderMedicineFuList = "";
                if (this.printMedicalOrder.orderMedicineFuList !== null && this.printMedicalOrder.orderMedicineFuList !== "") {
                    this.printMedicalOrder.orderMedicineFuList.forEach((med) => {
                        let meName = med.meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                        }
                        med.meName = meName;
                        this.showOrderMedicineFuList += med.meName + "(" + med.countNum + "g),";
                    });
                    this.showOrderMedicineFuList = this.showOrderMedicineFuList.substring(0, this.showOrderMedicineFuList.length - 1);
                }

                if (printDocMedicineArray.length > 0) {
                    printDocMedicineArray.forEach(docMedlist => {
                        docMedlist.decoctWay = docMedlist.decoctionId;
                    });
                    this.printMedicalOrder.orderMedicineList = printDocMedicineArray;
                }
            });
        },

        // 打开病历弹窗
        openBingliInfo(orderId) {
            this.bingliOrderId = orderId;
            this.patientDialogVisible = true;
            this.isLoadingPatient = true;
            this.getMedicalOrderBingliInfo();
        },

        // 取消打印处方笺
        cancelOpenBingliInfo() {
            this.patientDialogVisible = false;
        },

        // 获取订单病历详情
        getMedicalOrderBingliInfo() {
            getMedicalOrderDetail(this.bingliOrderId).then(response => {
                console.log(response);
                this.isLoadingPatient = false;
                this.bingliInfo = response.data.data.docPatientProfile;
                if (this.bingliInfo.identity !== null && this.bingliInfo.identity !== "" && this.bingliInfo.identity !== undefined) {
                    let identityVal = this.bingliInfo.identity;
                    this.bingliInfo.identityVal = identityVal;
                    identityVal = identityVal.substr(0, 5) + "**********" + identityVal.substr(14, identityVal.length);
                    this.bingliInfo.identity = identityVal;
                }
                this.bingliMedicalOrder = response.data.data.medicalOrder;
            });
        },


        // 取消订单
        userCancelOrder(orderId) {
            this.orderId = orderId;
            this.$confirm('确定要取消/作废当前订单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.isCancelOrder = true;
                cancelOrder(this.orderId).then(response => {
                    if (response.data.code === 200) {
                        message("订单取消成功！", "success");
                        this.recordTableLoading = false;
                        this.recordLoadDisabled = false;
                        this.currentPageRecord = 1;
                        this.recordlist = [];
                        this.getPatientHiMedicalOrderListBySearchBtn();
                    } else {
                        message("订单取消失败！", "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消操作');
            })

        },


        // 订单收费
        userDeleteCaseOrder(orderId) {
            this.$confirm('确定要删除当前病例单吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                deleteCaseOrder(orderId).then(response => {
                    if (response.code === 200) {
                        message("病例单删除成功", "success");
                        this.recordTableLoading = false;
                        this.recordLoadDisabled = false;
                        this.currentPageRecord = 1;
                        this.recordlist = [];
                        this.getPatientHiMedicalOrderListBySearchBtn();
                    } else {
                        message("病例单删除失败", "error");
                    }
                })
            }).catch(() => {
                console.log('cancel delete case order');
            })
        },

        openPayScreen(orderId) {
            this.orderId = orderId;
            this.orderPayDialogVisible = true;
            this.getPrintMedicalOrderDetailInfo();
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
            this.getPrintMedicalOrderDetailInfo();
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },


        // 取消支付
        cancalPay() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },

        // 修改订单
        userEditOrder(orderId) {
            this.$confirm('确定要修改当前订单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem("conId");
                this.orderId = orderId;
                this.isEditOrder = true;
                this.getMedicalOrderDetailInfoForOneMore();
            }).catch(() => {
                console.log('用户取消操作');
            })
        },

        // 再来一单
        oneMoreOrder(orderId) {
            this.$confirm('确定依据当前订单信息再次下单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem("conId");
                this.isOneMoreOrder = true;
                this.orderId = orderId;
                this.getMedicalOrderDetailInfoForOneMore();
            }).catch(() => {
                console.log('用户取消操作');
            })
        },


        // 关闭订单详情
        closeOrderDetail() {
            this.orderDetailDialogVisible = false;
        },


        // 保存患者信息
        oneMoreSaveDocPateintProfileInfo() {
            // 确保医生ID已正确设置
            if (!this.doctorInfo || !this.doctorInfo.doctorId) {
                message("医生信息未正确加载，请刷新页面重试", "error");
                return;
            }
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.patientInfo.name = this.searchPatientName;

            var mobilePattern = /^1[3456789]\d{9}$/;
            let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            if (chackAlertMsg(this.patientInfo.docId, '患者未正确关联医师', 'error')
                && chackAlertMsg(this.patientInfo.name, '患者姓名不能为空', 'error')
                && chackAlertMsg(this.patientInfo.sex, '患者性别不能为空', 'error')
                && chackAlertMsg(this.patientInfo.phoneNumber, '患者联系电话不能为空', 'error')
                && chackAlertMsg(this.patientInfo.identity, '患者身份证不能为空', 'error')
            ) {
                if (!mobilePattern.test(this.patientInfo.phoneNumber)) {
                    message("手机号码格式不正确！", "error")
                } else if (!_IDRe18.test(this.patientInfo.identity) && !_IDre15.test(this.patientInfo.identity)) {
                    message("身份证号码格式不正确！", "error")
                } else {
                    saveDocPatientProfile(this.patientInfo).then(response => {
                        console.log(response);
                        if (response.code === 200) {
                            this.dppId = response.data;
                            this.chooseDppId = this.dppId;
                            // 修复：确保patientInfo中的dppId也同步更新
                            this.patientInfo.dppId = this.dppId;

                            console.log("患者基本信息保存成功, 新dppId:", this.dppId);

                            // 重置病历列表并查询新患者的病历
                            this.recordTableLoading = false;
                            this.recordLoadDisabled = false;
                            this.currentPageRecord = 1;
                            this.recordlist = [];
                            this.getPatientHiMedicalOrderListBySearchBtn();

                            // 继续保存开方信息
                            this.saveMedicalOrderInfo();
                        } else {
                            message(response.msg, "error");
                        }
                    })
                }
            }
        },


        // 获取订单详情信新模版弹窗关闭
        getOrderDetailStatus() {
            this.orderDetailDialogVisible = false;
            this.orderId = window.sessionStorage.getItem('orderId');
            this.again = window.sessionStorage.getItem('again');
            this.editOrder = window.sessionStorage.getItem('editOrder');
            console.log("this.orderId >>>> " + this.orderId);
            console.log("this.again >>>> " + this.again);
            console.log("this.editOrder >>>> " + this.editOrder);
            if (this.again !== "" && this.again !== null && this.again !== undefined) {
                this.isOneMoreOrder = true;
                if (this.again === "0") {
                    this.medicalOrder.oldOrderId = this.orderId;
                    if (this.choosePreId !== null && this.choosePreId !== "") {
                        this.getPrescriptionInfo();
                        window.sessionStorage.removeItem('choosePreId');
                    } else if (this.medicineList !== null && this.medicineList !== "") {
                        this.getMedicineList();
                    } else {
                        this.getMedicalOrderDetailInfoForOneMore();
                    }
                } else {
                    this.medicalOrder.oldOrderId = "";
                    if (this.choosePreId !== null && this.choosePreId !== "") {
                        this.getPrescriptionInfo();
                        window.sessionStorage.removeItem('choosePreId');
                    } else {
                        this.getMedicineList();
                    }
                }
            } else if (this.editOrder !== "" && this.editOrder !== null && this.editOrder !== undefined) {
                this.isEditOrder = true;
                console.log("this.isEditOrder >>>> " + this.isEditOrder);
                this.medicalOrder.oldOrderId = "";
                if (this.choosePreId !== null && this.choosePreId !== "") {
                    this.getPrescriptionInfo();
                    window.sessionStorage.removeItem('choosePreId');
                } else if (this.medicineList !== null && this.medicineList !== "") {
                    this.getMedicineList();
                } else {
                    this.getMedicalOrderDetailInfoForOneMore();
                }
            } else {
                this.isOneMoreOrder = false;
                this.medicalOrder.oldOrderId = "";
                if (this.choosePreId !== null && this.choosePreId !== "") {
                    this.getPrescriptionInfo();
                    window.sessionStorage.removeItem('choosePreId');
                } else {
                    this.getMedicineList();
                }
            }
        },


        // 获取订单详情(再来一单)
        getMedicalOrderDetailInfoForOneMore() {
            getMedicalOrderDetailForOneMore(this.orderId).then(response => {
                console.log("getMedicalOrderDetailInfoForOneMore >>>> ");
                console.log(response);
                this.patientInfo = response.data.data.docPatientProfile;
                this.medicalOrder = response.data.data.medicalOrder;
                this.searchPatientName = this.patientInfo.name;
                this.parseMedinalOrderDetail(); // 订单详情分析
            });

        },

        // 获取订单详情
        getMedicalOrderDetailInfo() {
            getMedicalOrderDetail(this.orderId).then(response => {
                console.log(response);
                this.patientInfo = response.data.data.docPatientProfile;
                this.medicalOrder = response.data.data.medicalOrder;
                this.searchPatientName = this.patientInfo.name;
                this.parseMedinalOrderDetail(); // 订单详情分析
            });
        },

        // 订单详情分析
        parseMedinalOrderDetail() {
            if (this.medicalOrder.docAdvice === null) {
                this.medicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
            }
            if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
            }
            if (this.medicalOrder.takeWay === "null" || this.medicalOrder.takeWay === null) {
                this.medicalOrder.takeWay = "0";
            }
            if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this.medicalOrder.viceNum === "") {
                this.medicalOrder.viceNum = "1";
            }
            if (this.medicalOrder.useAttention !== null && this.medicalOrder.useAttention !== undefined && this.medicalOrder.useAttention !== "") {
                this.useAttention = this.medicalOrder.useAttention.split(",");
            }
            this.indexMedicine = this.medicalOrder.billingType === null ? '0' : this.medicalOrder.billingType;

            this.medicalOrder.packWay = this.medicalOrder.packWay === null ? '0' : this.medicalOrder.packWay;
            this.changeGaoWay(this.medicalOrder.packWay);

            this.medicalOrder.dayTakeNum = this.medicalOrder.dayTakeNum === null ? '1' : this.medicalOrder.dayTakeNum;//X日一剂
            this.medicalOrder.takeTimes = this.medicalOrder.takeTimes === null ? '2' : this.medicalOrder.takeTimes;// 每日分X次服用/每日X次
            this.medicalOrder.timeUseNum = this.medicalOrder.timeUseNum === null ? '1' : this.medicalOrder.timeUseNum;// 每次XX克、XX毫升

            this.docMedicineArray = [];
            var orderMedicineList = this.medicalOrder.orderMedicineList;
            console.log("orderMedicineList");
            console.log(orderMedicineList);
            if (orderMedicineList !== null) {
                orderMedicineList.forEach(melist => {
                    let decoctWay = melist.decoctWay;
                    let decoctionName = getDecoctionName(decoctWay);
                    melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                    if (this.medicalOrder.billingType === "0") {
                        if (melist.newGCount === null) {
                            melist.newGCount = melist.countNum;
                        }
                        if (this.newRuleOpen) {
                            melist.countNum = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                        } else {
                            melist.countNum = melist.newGCount;
                        }
                    } else {
                        melist.newGCount = melist.countNum;
                    }
                    let mCount = parseFloat(parseFloat(melist.countNum) * parseFloat(melist.price)).toFixed(2);
                    if (melist.meStatus === null || melist.meStatus === "" || melist.meStatus === undefined) {
                        melist.meStatus = "0";
                    }
                    this.docMedicineArray.push({
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        price: melist.price,
                        gCount: melist.countNum,
                        newGCount: melist.newGCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meDesc,
                        mCount: mCount,
                        decoctionId: decoctWay,
                        decoctionName: decoctionName,
                        drugProperty: melist.drugProperty,
                        meStatus: melist.meStatus,
                        isLimitUsage: melist.isLimitUsage,
                        limitThreshold: melist.limitThreshold
                    });
                })
            }

            this.chooseFuliaoList = [];
            var orderMedicineFuList = this.medicalOrder.orderMedicineFuList;
            console.log("orderMedicineFuList");
            console.log(orderMedicineFuList);
            if (orderMedicineFuList !== null) {
                orderMedicineFuList.forEach(melist => {
                    this.chooseFuliaoList.push({
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        meDesc: melist.meDesc,
                        price: melist.price,
                        meCount: melist.countNum,
                        countPrice: melist.totalPrice
                    });
                })
            }

            if (this.docMedicineArray.length > 0) {
                this.docMedicineArray.forEach(docMedlist => {
                    docMedlist.decoctWay = docMedlist.decoctionId;
                });
                this.medicalOrder.orderMedicineList = this.docMedicineArray;
            }
            this.refreshUsageSigns();// 刷新超量签章信息
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
            window.sessionStorage.setItem("billingType", this.medicalOrder.billingType);
            this.reCount(true);

            this.patientInfo.docId = this.doctorInfo.doctorId;
            // if (this.isOneMoreOrder || this.isEditOrder) {
            //     this.oneMoreSaveDocPateintProfileInfo();
            // }
        },

        getPrescriptionInfo() {
            getPrescriptionDetail(this.choosePreId).then(response => {
                this.prescriptionInfo = response.data.data;
                console.log(response.data.data);
                if (this.prescriptionInfo.takeWay === "null" || this.prescriptionInfo.takeWay === null) {
                    this.prescriptionInfo.takeWay = "0";
                }
                if (this.medicineList !== null && this.medicineList !== "" && this.medicineList.length > 0) {
                    this.docMedicineArray = [];
                    this.medicineList.forEach(melist => {
                        melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        if (this.prescriptionInfo.billingType === "0") {
                            if (melist.newGCount === null) {
                                melist.newGCount = melist.gCount;
                            }
                            if (this.newRuleOpen) {
                                melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                            } else {
                                melist.gCount = melist.newGCount;
                            }
                        } else {
                            melist.newGCount = melist.gCount;
                        }
                        let mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                        if (melist.meStatus === null || melist.meStatus === "" || melist.meStatus === undefined) {
                            melist.meStatus = "0";
                        }
                        this.docMedicineArray.push({
                            medicineId: melist.medicineId,
                            meName: melist.meName,
                            price: melist.price,
                            gCount: melist.gCount,
                            newGCount: melist.newGCount,
                            newRatio: melist.newRatio,
                            standard: melist.standard,
                            meRemark: melist.meRemark,
                            mCount: mCount,
                            decoctionId: melist.decoctionId,
                            decoctionName: melist.decoctionName,
                            drugProperty: melist.drugProperty,
                            meStatus: melist.meStatus,
                            isLimitUsage: melist.isLimitUsage,
                            limitThreshold: melist.limitThreshold
                        });
                    })
                }
                this.doMedicineList = this.prescriptionInfo.docPrescriptionMedicineList;
                if (this.preMedWay !== null && this.preMedWay !== "" && this.preMedWay !== undefined) {
                    if (this.preMedWay === 'replace') {
                        this.docMedicineArray = [];
                        this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中
                    } else if (this.preMedWay === 'add') {
                        this.sameMedicineList = [];
                        if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                            this.doMedicineList.forEach((melist) => {
                                melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                                this.docMedicineArray.forEach((doMelist) => {
                                    if (doMelist.medicineId === melist.medicineId) {
                                        this.sameMedicineList.push(melist);
                                    }
                                })
                            })
                        }
                        console.log(this.sameMedicineList);
                        console.log(this.doMedicineList);
                        if (this.sameMedicineList.length > 0) {
                            this.$confirm("追加的药材中有" + this.sameMedicineList.length + "个药材已存在，将移除重复的药材后继续追加，是否继续？", '温馨提示', {
                                confirmButtonText: '继续',
                                cancelButtonText: '取消',
                                type: 'warning',
                            }).then(() => {
                                if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                                    // 修复：使用正确的filter逻辑移除重复药材
                                    this.doMedicineList = this.doMedicineList.filter((melist) => {
                                        return !this.sameMedicineList.some((sMelist) => sMelist.medicineId === melist.medicineId);
                                    });
                                }
                                this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中
                            }).catch(() => {
                                this.doMedicineList = this.prescriptionInfo.docPrescriptionMedicineList;
                                console.log('用户取消追加');
                            })
                        } else {
                            this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中
                        }
                    }
                }
                this.refreshUsageSigns();// 刷新超量签章信息
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
                window.sessionStorage.setItem("billingType", this.prescriptionInfo.billingType);

                this.medicalOrder.orderMedicineList = [];
                if (this.docMedicineArray.length > 0) {
                    this.docMedicineArray.forEach(docMedlist => {
                        docMedlist.decoctWay = docMedlist.decoctionId;
                    });
                    this.medicalOrder.orderMedicineList = this.docMedicineArray;
                }
                this.reCount(true);
                if (this.openMedicinalDrawerAfterPrescriptionImport) {
                    this.openMedicinalDrawerAfterPrescriptionImport = false;
                    this.$nextTick(() => this.openChooseMedicinalDrawer());
                }
            });
        },


        // 将处方模版的药品拼接到药品列表中
        docMedicineArrayPush() {
            console.log(this.doMedicineList);
            if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                this.doMedicineList.forEach((melist) => {
                    melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                    if (this.medicalOrder.billingType === "0") {
                        if (melist.newGCount === null) {
                            melist.newGCount = melist.gCount;
                        }
                        if (this.newRuleOpen) {
                            melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                        } else {
                            melist.gCount = melist.newGCount;
                        }
                    } else {
                        melist.newGCount = melist.gCount;
                    }
                    let mCount;
                    if (melist.gCount === "" || melist.gCount === null || melist.gCount === undefined) {
                        mCount = parseFloat(parseFloat(0) * parseFloat(melist.price)).toFixed(2);
                    } else {
                        mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                    }
                    if (melist.meStatus === null || melist.meStatus === "" || melist.meStatus === undefined) {
                        melist.meStatus = "0";
                    }
                    this.docMedicineArray.push({
                        changeMed: false,
                        focusMeName: false,
                        focusGcount: false,
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        price: melist.price,
                        gCount: melist.gCount,
                        newGCount: melist.newGCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meRemark,
                        mCount: mCount,
                        decoctionId: melist.decoctionId,
                        decoctionName: melist.decoctionName,
                        decoctWay: melist.decoctWay,
                        meStatus: melist.meStatus,
                        isLimitUsage: melist.isLimitUsage,
                        limitThreshold: melist.limitThreshold
                    });
                })
                this.refreshUsageSigns();// 刷新超量签章信息
            }
        },

        // 获取药材信息
        getMedicineList() {
            this.docMedicineArray = [];
            console.log(this.medicineList)
            if (this.medicineList !== null && this.medicineList !== "") {
                console.log("viceNum2s >>> " + this.medicalOrder.viceNum);
                if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this.medicalOrder.viceNum === "") {
                    this.medicalOrder.viceNum = "1";
                }
                this.medicineList.forEach(melist => {
                    melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                    if (this.medicalOrder.billingType === "0") {
                        if (melist.newGCount === null) {
                            melist.newGCount = melist.gCount;
                        }
                        if (this.newRuleOpen) {
                            melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                        } else {
                            melist.gCount = melist.newGCount;
                        }
                    } else {
                        melist.newGCount = melist.gCount;
                    }
                    if (melist.meStatus === null || melist.meStatus === "" || melist.meStatus === undefined) {
                        melist.meStatus = "0";
                    }
                    this.docMedicineArray.push({
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        price: melist.price,
                        gCount: melist.gCount,
                        newGCount: melist.newGCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meRemark,
                        mCount: melist.mCount,
                        decoctionId: melist.decoctionId,
                        decoctionName: melist.decoctionName,
                        drugProperty: melist.drugProperty,
                        meStatus: melist.meStatus,
                        isLimitUsage: melist.isLimitUsage,
                        limitThreshold: melist.limitThreshold
                    });
                })
            }

            this.medicalOrder.orderMedicineList = [];
            if (this.docMedicineArray.length > 0) {
                this.docMedicineArray.forEach(docMedlist => {
                    docMedlist.decoctWay = docMedlist.decoctionId;
                });
                this.medicalOrder.orderMedicineList = this.docMedicineArray;
            }
            this.refreshUsageSigns();// 刷新超量签章信息
            this.reCount(true);

        },

        // 查询配置信息
        qryListPharmacyConfig() {
            listPharmacyConfig(this.queryParams).then(response => {
                if (response.data.code === 200) {
                    this.pharmacyConfig = response.data.rows;
                    console.log(this.pharmacyConfig);
                    if (this.pharmacyConfig.length > 0) {
                        for (let i = 0; i < this.pharmacyConfig.length; i++) {
                            let configKey = this.pharmacyConfig[i].configKey;
                            let configValue = this.pharmacyConfig[i].configValue;
                            // 出膏率
                            if (configKey === 'medicine_gao_rate') {
                                let configValArr = configValue.split(',');
                                this.gao_rate_low = parseFloat(configValArr[0]);
                                this.gao_rate_high = parseFloat(configValArr[1]);
                            }
                            // 膏方起做克数
                            if (configKey === 'medicine_gao_line') {
                                this.gao_line = configValue;
                            }
                            // 膏方加工费用
                            if (configKey === 'medicine_gao_price') {
                                this.medicineGaoPrice = configValue;
                                this.medicineGaoStartPrice = parseInt(parseFloat(configValue) * 1000);
                            }
                            // 出丸率
                            if (configKey === 'medicine_shui_rate') {
                                let configValArr = configValue.split(',');
                                this.shui_rate_low = parseFloat(configValArr[0]);
                                this.shui_rate_high = parseFloat(configValArr[1]);
                            }
                            // 水丸起做克数
                            if (configKey === 'medicine_shui_line') {
                                this.shui_line = configValue;
                            }
                            // 水丸加工费用
                            if (configKey === "medicine_shui_price") {
                                this.medicineShuiPrice = configValue;
                                this.medicineShuiStartPrice = parseInt(parseFloat(configValue) * 500);
                            }
                            // 饮片每剂加工费用
                            if (configKey === 'daijian_price') {
                                this.medicineViceNumPrice = configValue;
                            }
                        }
                    }
                }

            });
        },


        changeGaoWay(gaoway) {
            this.medicalOrder.packWay = gaoway;
            if (gaoway === '0') {
                this.medicalOrder.timeUseNum = '1';
            } else {
                this.medicalOrder.timeUseNum = '10';
            }
        },

        // 获取药品总重
        getMedicineHeavyFn() {
            let allGCount = parseFloat(0);
            this.docMedicineArray.forEach(item => {
                allGCount += parseFloat(item.newGCount);
            })
            return allGCount;
        },

        // 药方总重统一按处方展示克重 newGCount 累加。
        getOrderWeightByNewGCount(medicineList) {
            if (!Array.isArray(medicineList)) {
                return '0.00';
            }
            const totalWeight = medicineList.reduce((total, item) => {
                const weight = parseFloat(item.newGCount);
                return total + (Number.isNaN(weight) ? 0 : weight);
            }, 0);
            return totalWeight.toFixed(2);
        },

        // 修改副数
        changeViceNum() {
            window.sessionStorage.setItem("viceNum", this.medicalOrder.viceNum);
            if (this.medicalOrder.takeTimes === "" || this.medicalOrder.takeTimes === null || this.medicalOrder.takeTimes === undefined) {
                this.medicalOrder.allViceNum = parseInt(0);
            } else {
                this.medicalOrder.allViceNum = parseInt(parseFloat(this.medicalOrder.viceNum) * parseFloat(this.medicalOrder.takeTimes));
            }
            this.reCount(true);
        },
        // 选择每日分几次
        changeDrinkTimes() {
            if (this.medicalOrder.takeTimes === "" || this.medicalOrder.takeTimes === null || this.medicalOrder.takeTimes === undefined) {
                this.medicalOrder.allViceNum = parseInt(0);
            } else {
                this.medicalOrder.allViceNum = parseInt(parseFloat(this.medicalOrder.viceNum) * parseFloat(this.medicalOrder.takeTimes));
            }
        },

        // 选择煎法
        chooseJian() {
            if (this.medicalOrder.takeTimes === "" || this.medicalOrder.takeTimes === null || this.medicalOrder.takeTimes === undefined) {
                this.medicalOrder.allViceNum = parseInt(0);
            } else {
                this.medicalOrder.allViceNum = parseInt(parseFloat(this.medicalOrder.viceNum) * parseFloat(this.medicalOrder.takeTimes));
            }
            if (this.medicalOrder.decoctType === '0') {
                this.medicalOrder.processingCosts = parseFloat(0).toFixed(2);
            } else {
                this.medicalOrder.processingCosts = parseFloat(parseFloat(this.medicalOrder.viceNum) * parseFloat(this.medicineViceNumPrice)).toFixed(2);
            }
            this.reCount(true);
        },

        // 选择剂型
        changeMedicineType() {
            const sourceMedicineType = `${this.medicalOrder.billingType}`;
            const targetMedicineType = `${this.indexMedicine}`;
            const herbMedicineTypes = ['1', '2', '3'];
            const isHerbMedicineTypeChange = herbMedicineTypes.includes(sourceMedicineType) &&
                herbMedicineTypes.includes(targetMedicineType) && sourceMedicineType !== targetMedicineType;
            const needsMedicineConversion = sourceMedicineType !== targetMedicineType &&
                ((sourceMedicineType === '0' && herbMedicineTypes.includes(targetMedicineType)) ||
                    (targetMedicineType === '0' && herbMedicineTypes.includes(sourceMedicineType)));
            const applyTypeChange = () => {
                this.medicalOrder.medicineType = targetMedicineType;
                this.medicalOrder.billingType = targetMedicineType;
                window.sessionStorage.setItem("billingType", targetMedicineType);
                this.afterChangeMedicineType();
            };
            if (isHerbMedicineTypeChange) {
                this.$confirm('饮片、膏方、水丸之间切换时，药材和剂量保持不变，仅切换对应剂型说明，是否继续?', '温馨提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(applyTypeChange).catch(() => {
                    this.indexMedicine = sourceMedicineType;
                });
                return;
            }
            if (!needsMedicineConversion || this.docMedicineArray.length === 0) {
                applyTypeChange();
                return;
            }
            this.$confirm('更换开方剂型将转换已选药品, 是否继续?', '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                this.transMedicineTypeData.meType = getMedicineConversionTargetType(targetMedicineType);
                this.transMedicineTypeForOrder(sourceMedicineType, targetMedicineType);
            }).catch(() => {
                this.indexMedicine = sourceMedicineType;
            });
        },

        transMedicineTypeForOrder(sourceMedicineType, targetMedicineType) {
            if (this.isMedicineTypeConverting) {
                return;
            }
            const conversionRequestId = ++this.medicineTypeConversionRequestId;
            this.isMedicineTypeConverting = true;
            const sourceMedicineList = this.docMedicineArray.map(item => ({...item}));
            const medicineList = sourceMedicineList.map((item, index) => ({
                medicineId: item.medicineId,
                countNum: sourceMedicineType === '0'
                    ? (item.newGCount === null || item.newGCount === undefined || item.newGCount === '' ? item.gCount : item.newGCount)
                    : (item.gCount === null || item.gCount === undefined || item.gCount === '' ? item.newGCount : item.gCount),
                meSeq: index
            }));
            const conversionData = {
                meType: getMedicineConversionTargetType(targetMedicineType),
                medicineList
            };
            transMedicalType(conversionData).then(response => {
                if (conversionRequestId !== this.medicineTypeConversionRequestId) {
                    return;
                }
                if (response.code !== 200) {
                    throw new Error(response.msg || '药品剂型转换失败');
                }
                const transData = response.data || {};
                const resList = Array.isArray(transData.resList) ? transData.resList : [];
                const lackMedicineNames = String(transData.lackMedicine || '')
                    .split(/[,，、]/)
                    .map(name => name.replaceAll('配方', '').replaceAll('颗粒', '').replaceAll('饮片', '').trim())
                    .filter(Boolean);
                const isLackMedicine = (medicine) => {
                    const medicineName = (medicine.meName || '').replaceAll('配方', '').replaceAll('颗粒', '').replaceAll('饮片', '').trim();
                    return lackMedicineNames.some(name => medicineName.includes(name) || name.includes(medicineName));
                };
                if (resList.length === 0) {
                    throw new Error('药品剂型转换未返回有效药材，已保留原药材清单');
                }
                this.docMedicineArray = resList.map(melist => {
                    const newGCount = melist.newGCount === null || melist.newGCount === undefined ? melist.countNum : melist.newGCount;
                    const gCount = targetMedicineType === '0'
                        ? (this.newRuleOpen ? parseFloat(parseFloat(newGCount) * parseFloat(melist.newRatio)).toFixed(2) : newGCount)
                        : melist.countNum;
                    return {
                        medicineId: melist.medicineId,
                        meName: (melist.meName || '').replaceAll('配方', '').replaceAll('颗粒', '').replaceAll('饮片', ''),
                        price: melist.medicinePrice,
                        gCount,
                        newGCount: targetMedicineType === '0' ? newGCount : gCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meDesc,
                        mCount: parseFloat(parseFloat(gCount) * parseFloat(melist.medicinePrice)).toFixed(2),
                        decoctionId: melist.decoctWay || '',
                        decoctionName: getDecoctionName(melist.decoctWay),
                        decoctWay: melist.decoctWay || '',
                        drugProperty: melist.drugProperty || '',
                        meStatus: melist.meStatus || '0',
                        isLimitUsage: melist.isLimitUsage,
                        limitThreshold: melist.limitThreshold,
                        isLackMedicine: isLackMedicine(melist)
                    };
                }).sort((left, right) => Number(left.isLackMedicine) - Number(right.isLackMedicine));
                this.medicalOrder.billingType = targetMedicineType;
                this.medicalOrder.medicineType = targetMedicineType;
                this.medicalOrder.orderMedicineList = this.docMedicineArray;
                window.sessionStorage.setItem('billingType', targetMedicineType);
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
                this.refreshUsageSigns();
                this.afterChangeMedicineType();
                const lackMedicine = transData.lackMedicine;
                if (lackMedicine) {
                    const lackMedicineText = lackMedicineNames.join('、');
                    this.$alert(`【${lackMedicineText}】药材有缺失，请替换或移除缺失药材！`, '温馨提示')
                        .then(() => {
                            this.$nextTick(() => this.openChooseMedicinalDrawer());
                        });
                }
            }).catch(error => {
                if (conversionRequestId !== this.medicineTypeConversionRequestId) {
                    return;
                }
                this.docMedicineArray = sourceMedicineList;
                this.medicalOrder.orderMedicineList = sourceMedicineList;
                this.medicalOrder.billingType = sourceMedicineType;
                this.medicalOrder.medicineType = sourceMedicineType;
                this.indexMedicine = sourceMedicineType;
                window.sessionStorage.setItem('billingType', sourceMedicineType);
                window.sessionStorage.setItem('medicineList', JSON.stringify(sourceMedicineList));
                message(error.message || error, 'error');
            }).finally(() => {
                if (conversionRequestId === this.medicineTypeConversionRequestId) {
                    this.isMedicineTypeConverting = false;
                }
            });
        },


        // 修改剂型后的处理逻辑
        afterChangeMedicineType() {
            if (this.indexMedicine === '0') {
                this.medicalOrder.viceNum = "7";
                this.medicalOrder.timeUseNum = "2";
                this.medicalOrder.docAdvice = "加入100~150ml开水搅拌，放置常温服用";
            } else if (this.indexMedicine === '1') {
                this.medicalOrder.viceNum = "7";
                this.medicalOrder.timeUseNum = "2";
                this.medicalOrder.docAdvice = "开水温服";
                if (this.medicalOrder.takeTimes === "" || this.medicalOrder.takeTimes === null || this.medicalOrder.takeTimes === undefined) {
                    this.medicalOrder.allViceNum = parseInt(0);
                } else {
                    this.medicalOrder.allViceNum = parseInt(parseFloat(this.medicalOrder.viceNum) * parseFloat(this.medicalOrder.takeTimes));
                }
            } else if (this.indexMedicine === '2') {
                this.medicalOrder.viceNum = "1";
                this.medicalOrder.timeUseNum = "1";
                this.qryFuliaoMedicineList(); // 查询辅料列表
                this.medicalOrder.docAdvice = "开水温服";
                this.toAddFuliaoMedical(); // 新增辅料
            } else if (this.indexMedicine === '3') {
                this.medicalOrder.viceNum = "1";
                this.medicalOrder.timeUseNum = "10";
                this.medicalOrder.docAdvice = "开水温服";
            }
            this.reCount(true);
        },


        // 查询辅料信息
        qryFuliaoMedicineList() {
            this.fuliaoList = [];
            this.queryParams.meType = 2;
            listFuMedicine(this.queryParams).then(response => {
                if (response.data.code === 200) {
                    this.fuliaoList = response.data.rows;
                    console.log(this.fuliaoList);
                    this.fuliaoList.forEach((fuItem) => {
                        fuItem.meList.forEach((liItem) => {
                            liItem.isChoosed = false;
                        })
                    })
                }
            });
        },

        // 获取辅料药品总重
        getFuliaoMedHeavyFn() {
            let allFuGCount = parseFloat(0);
            this.chooseFuliaoList.forEach(item => {
                allFuGCount += parseFloat(item.meCount);
            })
            return allFuGCount;
        },

        // 计算辅料药品总价
        getFuliaoMedPriceFn() {
            let allFuPrice = parseFloat(0);
            this.chooseFuliaoList.forEach(item => {
                allFuPrice += parseFloat(item.countPrice);
            })
            return allFuPrice;
        },

        // 选择药材
        openChooseMedicinalDrawer() {
            // 抽屉编辑必须以当前激活处方为准，避免复用其他处方的全局缓存
            window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray || []));
            window.sessionStorage.setItem('billingType', String(this.medicalOrder.billingType));
            this.medicineList = JSON.parse(JSON.stringify(this.docMedicineArray || []));
            this.medicinalChooseDrawer = true;
        },

        // 选择药材弹窗关闭
        getMedicinalDrawerStatus() {
            this.medicinalChooseDrawer = false;
            const billingType = window.sessionStorage.getItem('billingType');
            if (billingType !== "" && billingType !== null && billingType !== undefined) {
                this.medicalOrder.billingType = billingType;
                this.medicalOrder.medicineType = billingType;
                this.indexMedicine = billingType;
            }
            console.log(window.sessionStorage.getItem("medicineList"));
            this.medicineList = JSON.parse(window.sessionStorage.getItem("medicineList"));
            this.getMedicineList();
            this.afterChangeMedicineType();
            this.updateActivePrescriptionDraft();
        },

        // 关闭药材选择弹窗
        closeMedicinalChooseDrawer() {
            // 调用药材选择组件内的保存药材的方法
            this.$refs.medicinalChoose.sureEditPopup();
        },

        // 修改诊金
        changeDocPrice() {
            this.reCount();
        },

        // 修改病程管理费用
        editAdjustmentPriceValue() {
            if (this.docMedicineArray.length > 0) {
                // 记录修改前的值，取消修改时回退使用
                this.preEditAdjustmentPrice = this.medicalOrder.adjustmentPrice;
                this.hadEditAdjustmentPrice = true;
                this.editAdjustmentPrice = true;
                this.dailyFee = parseFloat(this.medicalOrder.adjustmentPrice / this.serviceDays).toFixed(2);
            } else {
                message("请先选择药材后再设置诊后病程管理费用！", "error");
            }
        },

        // 确定修改病程管理费用（确定后修改才生效）
        sureEditAdjustmentPriceValue() {
            this.hadEditAdjustmentPrice = true;
            this.editAdjustmentPrice = false;
            this.preEditAdjustmentPrice = null;
            this.reCount();
        },

        // 取消修改病程管理费用（回退到修改前的值）
        cancelEditAdjustmentPriceValue() {
            this.editAdjustmentPrice = false;
            if (this.preEditAdjustmentPrice !== null && this.preEditAdjustmentPrice !== undefined) {
                this.medicalOrder.adjustmentPrice = this.preEditAdjustmentPrice;
            }
            this.preEditAdjustmentPrice = null;
            this.reCount();
        },

        // 修改病程管理费用（编辑中仅预览每日费用，确定后才真正生效）
        changeAdjustmentPrice() {
            if (this.editAdjustmentPrice) {
                // 编辑状态下仅更新每日费用预览，不重算总价
                this.dailyFee = parseFloat(this.medicalOrder.adjustmentPrice / this.serviceDays).toFixed(2);
            } else {
                this.reCount();
            }
        },

        // 修改优惠金额
        changeDiscountPrice() {
            this.reCount();
        },

        // 删除辅料
        deleteFuliao(medicineId) {
            this.chooseFuliaoList.forEach((item, index) => {
                if (item.medicineId === medicineId) {
                    this.chooseFuliaoList.splice(index, 1);
                }
            })
            this.fuliaoList.forEach((fuItem) => {
                fuItem.meList.forEach((liItem) => {
                    liItem.isChoosed = false;
                    this.chooseFuliaoList.forEach((item) => {
                        if (item.medicineId === liItem.medicineId) {
                            liItem.isChoosed = true;
                        }
                    })

                })
            })
            this.reCount(true);
        },

        // 选择辅料
        chooseFuliaoFunc(itm) {
            console.log(itm)
            this.fuliaoList.forEach((fuItem) => {
                fuItem.meList.forEach((liItem) => {
                    if (liItem.medicineId === itm.medicineId) {
                        itm.price = liItem.price;
                        itm.meName = liItem.meName;
                        itm.meDesc = liItem.meDesc;
                    }
                })
            })
            this.chooseFuliaoList.forEach((item) => {
                if (item.medicineId === itm.medicineId) {
                    console.log(itm.price)
                    console.log(itm.meCount)
                    item.price = itm.price;
                    item.meCount = itm.meCount;
                    item.meName = itm.meName;
                    item.meDesc = itm.meDesc;
                    item.countPrice = parseFloat(parseFloat(item.price).toFixed(2) * parseFloat(item.meCount).toFixed(2)).toFixed(2);
                    this.$nextTick(() => {
                        this.$refs[`meCount${item.medicineId}`][0].select();
                    })
                }
            })
            this.fuliaoList.forEach((fuItem) => {
                fuItem.meList.forEach((liItem) => {
                    liItem.isChoosed = false;
                    this.chooseFuliaoList.forEach((item) => {
                        if (item.medicineId === liItem.medicineId) {
                            liItem.isChoosed = true;
                        }
                    })

                })
            })

        },

        // 修改辅料重量
        changeFuliaoCount(itm) {
            console.log(itm)
            let countPrice = parseFloat(parseFloat(itm.price).toFixed(2) * parseFloat(itm.meCount).toFixed(2)).toFixed(2);
            this.chooseFuliaoList.forEach((item) => {
                if (item.medicineId === itm.medicineId) {
                    console.log(itm.price)
                    console.log(itm.meCount)
                    item.price = itm.price;
                    item.meCount = itm.meCount;
                    item.meName = itm.meName;
                    item.meDesc = itm.meDesc;
                    item.countPrice = countPrice
                }
            })
            this.reCount(true);
        },

        // 新增辅料药材
        toAddFuliaoMedical() {
            this.chooseFuliaoList.push({
                medicineId: null,
                meName: null,
                meDesc: null,
                price: parseFloat(0).toFixed(2),
                meCount: parseFloat(0).toFixed(2),
                countPrice: parseFloat(0).toFixed(2)
            });
        },


        // 选择处方模板
        openPrescriptionDrew() {
            this.prescriptionDialogVisible = true;
        },

        // 选择处方模版弹窗关闭
        getPreDrawerStatus() {
            this.prescriptionDialogVisible = false;
            this.choosePreId = window.sessionStorage.getItem('choosePreId');
            this.preMedWay = window.sessionStorage.getItem('addType'); // 选择常用处方时，药材的添加方式（替换或追加）
            if (this.choosePreId !== null && this.choosePreId !== "") {
                this.openMedicinalDrawerAfterPrescriptionImport = true;
                this.getPrescriptionInfo();
                window.sessionStorage.removeItem('choosePreId');
            }
            let billingType = window.sessionStorage.getItem('billingType');
            if (billingType !== "" && billingType !== null && billingType !== undefined) {
                this.medicalOrder.billingType = billingType;
                this.indexMedicine = billingType;
                this.afterChangeMedicineType();
            } else {
                window.sessionStorage.setItem("billingType", "0");
            }
        },

        // 选择禁忌
        useAttentionChoose() {
            console.log(this.useAttention);
            this.medicalOrder.useAttention = this.useAttention.join(",");
        },

        // 选择配送省市区
        chooseRegionData() {
            console.log(this.receiveRegion);
            this.medicalOrder.receiveProvince = this.receiveRegion[0];
            this.medicalOrder.receiveCity = this.receiveRegion[1];
            this.medicalOrder.receiveCountry = this.receiveRegion[2];
        },

        // 选择配送方式
        changeDeliverWayType() {
            console.log(this.medicalOrder.deliverWay);
            if (this.medicalOrder.deliverWay === "0") {
                this.medicalOrder.receivePersonName = this.patientInfo.name;
                this.medicalOrder.receivePhone = this.patientInfo.phoneNumber;
                this.receiveRegion = this.patientRegion;
                this.medicalOrder.receiveAddress = this.patientAddress;
            }
        },


        // 药费重新计算   诊费  调理费用
        reCount(resetAdjustmentPrice = false) {
            console.log("reCount");
            console.log(this.medicalOrder.billingType);
            this.medicineTotle = this.docMedicineArray.length;
            this.medicineHeavy = parseFloat(this.getMedicineHeavyFn()).toFixed(2);
            this.medicalOrder.orderMedicineList = [];
            let countPrice = 0;
            if (this.docMedicineArray.length > 0) {
                this.medicalOrder.orderMedicineList = this.docMedicineArray;
                this.docMedicineArray.forEach(mlist => {
                    countPrice += parseFloat(mlist.mCount);
                });
                console.log("countPrice >>>>> " + countPrice);
                this.medSingleCounPrice = parseFloat(countPrice).toFixed(2);
                console.log("this.medicalOrder.viceNum >>>>> " + this.medicalOrder.viceNum);
                if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this.medicalOrder.viceNum === "") {
                    this.medicalOrder.medicalCountPrice = parseFloat(0).toFixed(2);
                } else {
                    this.medicalOrder.medicalCountPrice = parseFloat(countPrice * this.medicalOrder.viceNum).toFixed(2);
                }
                console.log("this.medicalOrder.medicalCountPrice >>>>> " + this.medicalOrder.medicalCountPrice);

                // // 历史版本（诊费=药费*诊费设置比例）
                // if (this.doctorInfo.clinicDocPriceWay === "0") {
                //     this.medicalOrder.docPrice = parseFloat(this.doctorInfo.clinicDocPrice).toFixed(2);
                // } else {
                //     this.medicalOrder.docPrice = parseFloat(parseFloat(this.medicalOrder.medicalCountPrice) * parseFloat(this.doctorInfo.clinicDocPriceRate * 0.01)).toFixed(2);
                // }
                // console.log("this.medicalOrder.docPrice >>>>> " + this.medicalOrder.docPrice);

                this.medicalOrder.processingCosts = parseFloat(0).toFixed(2);
                console.log("this.medicalOrder.billingType");
                if (this.medicalOrder.billingType === '1') {
                    if (this.medicalOrder.decoctType === '0') {
                        this.medicalOrder.processingCosts = parseFloat(0).toFixed(2);
                    } else {
                        this.medicalOrder.processingCosts = parseFloat(parseFloat(this.medicalOrder.viceNum) * parseFloat(this.medicineViceNumPrice)).toFixed(2); // 加工费用
                    }
                } else if (this.medicalOrder.billingType === '2') {
                    this.medicineHeavy = parseFloat(parseFloat(this.getFuliaoMedHeavyFn()) + parseFloat(this.getMedicineHeavyFn())).toFixed(2);
                    this.medicalOrder.fuCountPrice = this.getFuliaoMedPriceFn();// 计算辅料药品总价
                    this.orderMedicalCountPrice = parseFloat(parseFloat(this.medicalOrder.medicalCountPrice) + parseFloat(this.medicalOrder.fuCountPrice)).toFixed(2);
                    this.medicalOrder.processingCosts = parseFloat(parseFloat(this.medicineHeavy) * parseFloat(this.medicineGaoPrice)).toFixed(2); // 加工费用

                    this.medicalOrder.orderMedicineFuList = [];
                    if (this.chooseFuliaoList.length > 0) {
                        this.medicalOrder.orderMedicineFuList = this.chooseFuliaoList;
                    }
                } else if (this.medicalOrder.billingType === '3') {
                    this.medicalOrder.processingCosts = parseFloat(parseFloat(this.medicineHeavy) * parseFloat(this.medicineShuiPrice)).toFixed(2); // 加工费用
                }
                console.log("this.medicalOrder.medicalCountPrice");
                console.log(this.medicalOrder.medicalCountPrice)
                if (this.medicalOrder.fuCountPrice === null || this.medicalOrder.fuCountPrice === undefined || this.medicalOrder.fuCountPrice === "") {
                    this.medicalOrder.fuCountPrice = parseFloat(0).toFixed(2);
                }
                console.log("this.medicalOrder.fuCountPrice");
                console.log(this.medicalOrder.fuCountPrice)
                this.orderMedicalCountPrice = parseFloat(parseFloat(this.medicalOrder.medicalCountPrice) + parseFloat(this.medicalOrder.fuCountPrice)).toFixed(2);
                console.log("this.orderMedicalCountPrice");
                console.log(this.orderMedicalCountPrice)
                this.medicalOrder.orderPrice = parseFloat(parseFloat(this.orderMedicalCountPrice) + parseFloat(this.medicalOrder.docPrice)).toFixed(2);
                this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(this.medicalOrder.processingCosts)).toFixed(2);
            } else {
                this.medicalOrder.orderPrice = parseFloat(0).toFixed(2);
                this.medicalOrder.medicalCountPrice = parseFloat(0).toFixed(2);
                this.medSingleCounPrice = parseFloat(0).toFixed(2);
                this.orderMedicalCountPrice = parseFloat(0).toFixed(2);

                // // 历史版本（诊费=药费*诊费设置比例）
                // console.log("this.doctorInfo.clinicDocPriceWay");
                // console.log(this.doctorInfo.clinicDocPriceWay)
                // if (this.doctorInfo.clinicDocPriceWay === "0") {
                //     this.medicalOrder.docPrice = parseFloat(this.doctorInfo.clinicDocPrice).toFixed(2);
                // } else {
                //     this.medicalOrder.docPrice = parseFloat(0).toFixed(2);
                // }
                // console.log("this.medicalOrder.docPrice");
                // console.log(this.medicalOrder.docPrice)
                this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(this.medicalOrder.docPrice)).toFixed(2);
            }

            this.medicalOrder.orderWeight = this.medicineHeavy;
            console.log("this..gao_rate_low");
            console.log(this.gao_rate_low)
            this.gao_heavy_low = parseFloat(parseFloat(this.medicineHeavy) * parseFloat(this.gao_rate_low / 100).toFixed(2)).toFixed(2);
            this.gao_heavy_high = parseFloat(parseFloat(this.medicineHeavy) * parseFloat(this.gao_rate_high / 100).toFixed(2)).toFixed(2);
            this.shui_heavy_low = parseFloat(parseFloat(this.medicineHeavy) * parseFloat(this.shui_rate_low / 100).toFixed(2)).toFixed(2);
            this.shui_heavy_high = parseFloat(parseFloat(this.medicineHeavy) * parseFloat(this.shui_rate_high / 100).toFixed(2)).toFixed(2);

            if (this.medicalOrder.adjustmentPrice === null || this.medicalOrder.adjustmentPrice === undefined || this
                .medicalOrder.adjustmentPrice === '') {
                this.medicalOrder.adjustmentPrice = "";
            }

            if (this.medicalOrder.docPrice === null || this.medicalOrder.docPrice === undefined || this.medicalOrder.docPrice === '') {
                this.medicalOrder.docPrice = "";
            }

            if (this.medicalOrder.discountPrice === null || this.medicalOrder.discountPrice === undefined ||
                this.medicalOrder.discountPrice === '') {
                this.medicalOrder.discountPrice = "";
            }

            // 诊后管理费用设置
            this.serviceDays = this.orderServiceDays();
            // 药材变更时重置病程管理费用，按新药材费用重新计算默认值
            if (resetAdjustmentPrice) {
                this.hadEditAdjustmentPrice = false;
                this.editAdjustmentPrice = false;
            }
            if (this.orderMedicalCountPrice === null || this.orderMedicalCountPrice === undefined || this.orderMedicalCountPrice === "") {
                this.medicalOrder.adjustmentPrice = parseFloat(0).toFixed(2);
                this.dailyFee = parseFloat(0).toFixed(2);
            } else {
                // 最大值按医生配置的比例最大值 treatFeeMaxRate 计算（未配置回退 treatFeeRate）
                this.maxFee = this.getMaxFee(toNumber(this.orderMedicalCountPrice));
                // 默认值按医生设置的比例值 treatFeeRate 计算；不超过最大值（防止存量数据 treatFeeRate 超过上限时默认值越界）
                const defaultFee = Math.min(this.getDefaultFee(toNumber(this.orderMedicalCountPrice)), this.maxFee);
                if (!this.hadEditAdjustmentPrice) {
                    this.medicalOrder.adjustmentPrice = defaultFee;
                }
                // 下拉选项：默认值和最大值按实际整数值展示，其余按5步长
                this.feeOptions = buildFeeOptions(this.maxFee, defaultFee);
                this.dailyFee = parseFloat(this.medicalOrder.adjustmentPrice / this.serviceDays).toFixed(2);
            }
            console.log("this.medicalOrder.adjustmentPrice");
            console.log(this.medicalOrder.adjustmentPrice)
            console.log("this.medicalOrder.orderPrice");
            console.log(this.medicalOrder.orderPrice)

            // if (this.medicalOrder.adjustmentPrice === "" && this.medicalOrder.discountPrice === "") {
            //     this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(0) - parseFloat(0)).toFixed(2);
            // } else if (this.medicalOrder.adjustmentPrice !== "" && this.medicalOrder.discountPrice === "") {
            //     this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(this.medicalOrder.adjustmentPrice) - parseFloat(0)).toFixed(2);
            // } else if (this.medicalOrder.adjustmentPrice === "" && this.medicalOrder.discountPrice !== "") {
            //     this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(0) - parseFloat(this.medicalOrder.discountPrice)).toFixed(2);
            // } else if (this.medicalOrder.adjustmentPrice !== "" && this.medicalOrder.discountPrice !== "") {
            //     this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(this.medicalOrder.adjustmentPrice) - parseFloat(this.medicalOrder.discountPrice)).toFixed(2);
            // }
            this.medicalOrder.patientOperationHistory = this.patientInfo.allergyHistory; // 过敏史

            this.medicalOrder.orderPrice = parseFloat(parseFloat(this.medicalOrder.orderPrice) + parseFloat(this.medicalOrder.adjustmentPrice)).toFixed(2);

        },



        // 计算服务天数
        orderServiceDays() {
            const viceNum = toNumber(this.medicalOrder.viceNum);
            const dayTakeNum = toNumber(this.medicalOrder.dayTakeNum) || 1;
            if (viceNum <= 0) {
                return ORDER_ADD_SERVICE_DAYS;
            }
            if (this.medicalOrder.billingType === '0' || this.medicalOrder.billingType === '1') {
                return Math.max(1, Math.round(viceNum * dayTakeNum));
            }
            return Math.max(1, Math.round(viceNum));
        },



        // 订单信息校验
        chackOrderInfo() {
            // 将患者信息同步至药方的患者信息字段
            this.medicalOrder.patientPhone = this.patientInfo.phoneNumber;
            this.medicalOrder.patientName = this.patientInfo.name;
            this.medicalOrder.patientSex = this.patientInfo.sex;
            this.medicalOrder.patientAge = this.patientInfo.age;
            this.medicalOrder.patientIdentity = this.patientInfo.identity;
            this.patientInfo.dppId = this.dppId;
            this.medicalOrder.dppId = this.dppId;

            // 判断调理费用和药品价格
            let adjP = false;
            if (this.medicalOrder.discountPrice !== null && this.medicalOrder.discountPrice !== undefined && this.medicalOrder.discountPrice !== '') {
                const m = parseFloat(this.medicalOrder.discountPrice) - parseFloat(this.medicalOrder.medicalCountPrice) * 0.3;
                adjP = m > 0
            }

            let reg = /^1[3-9]\d{9}$/;
            if (this.medicalOrder.patientPhone === null || this.medicalOrder.patientPhone === "" || this.medicalOrder.patientPhone === undefined) {
                message("患者手机号不能为空！", "error");
                return false;
            } else if (!reg.test(this.medicalOrder.patientPhone)) {
                message("患者手机号格式不正确！", "error");
                return false;
            } else {
                this.medicalOrder.smsPhone = this.medicalOrder.patientPhone;
                // return true;
            }
            if (this.medicalOrder.billingType === '0' || this.medicalOrder.billingType === '1') {
                if (this.medicalOrder.takeWay === null || this.medicalOrder.takeWay === "" || this.medicalOrder.takeWay === undefined) {
                    message("用药方法不能为空！", "error");
                    return false;
                }
            } else if (this.medicalOrder.billingType === '2') {
                if (this.chooseFuliaoList.length <= 0) {
                    message("膏方下辅料不能为空！", "error");
                    return false;
                }
                // 修复：使用for循环替代forEach，以便正确return终止函数
                for (let i = 0; i < this.chooseFuliaoList.length; i++) {
                    const item = this.chooseFuliaoList[i];
                    item.countNum = item.meCount;
                    if (!item.meCount || item.meCount === 0 || parseFloat(item.meCount) === 0) {
                        message("辅料（" + item.meName + "）的重量不能为0！", "error");
                        return false;
                    }
                }

                if (parseFloat(this.medicineHeavy) < parseFloat(this.gao_line)) {
                    message("膏方药材总量" + this.gao_line + "g起做！", "error");
                    return false;
                }
            } else if (this.medicalOrder.billingType === '3') {
                if (parseFloat(this.medicineHeavy) < parseFloat(this.shui_line)) {
                    message("水丸药材总量" + this.shui_line + "g起做！", "error");
                    return false;
                }
            }

            if (this.medicalOrder.deliverWay === '0') {
                let mobilePattern = /^1[3-9]\d{9}$/;
                if (this.medicalOrder.receivePersonName === null || this.medicalOrder.receivePersonName === "" || this.medicalOrder.receivePersonName === undefined) {
                    message("物流配送的收货人姓名不能为空！", "error");
                    return false;
                } else if (this.medicalOrder.receivePhone === null || this.medicalOrder.receivePhone === "" || this.medicalOrder.receivePhone === undefined) {
                    message("物流配送的收货人手机号不能为空！", "error");
                    return false;
                } else if (!mobilePattern.test(this.medicalOrder.receivePhone)) {
                    message("物流配送的收货人手机号格式不正确！", "error");
                    return false;
                } else if (this.medicalOrder.receiveProvince === null || this.medicalOrder.receiveProvince === "" || this.medicalOrder.receiveProvince === undefined) {
                    message("物流配送的省/市/区不能为空！", "error");
                    return false;
                } else if (this.medicalOrder.receiveAddress === null || this.medicalOrder.receiveAddress === "" || this.medicalOrder.receiveAddress === undefined) {
                    message("物流配送的收货地址不能为空！", "error");
                    return false;
                }
            }

            if (this.medicalOrder.dppId === null || this.medicalOrder.dppId === "" || this.medicalOrder.dppId === undefined) {
                message("关联患者信息为空", "error");
                return false;
            } else if (this.medicalOrder.patientName === null || this.medicalOrder.patientName === "" || this.medicalOrder.patientName === undefined) {
                message("请输入患者姓名", "error");
                return false;
            } else if (this.medicalOrder.patientSex == null || this.medicalOrder.patientSex === "" || this.medicalOrder.patientSex === undefined) {
                message("请选择患者性别", "error");
                return false;
            } else if (this.medicalOrder.clinicalDiagnosis == null || this.medicalOrder.clinicalDiagnosis === "" || this.medicalOrder.clinicalDiagnosis === undefined) {
                message("诊断信息不能为空", "error");
                return false;
            } else if (this.medicalOrder.billingType == null || this.medicalOrder.billingType === "" || this.medicalOrder.billingType === undefined) {
                message("剂型不能为空", "error");
                return false;
            } else if (this.medicalOrder.orderMedicineList <= 0) {
                message("药方药品不能为空", "error");
                return false;
            } else if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === "" || this.medicalOrder.viceNum === undefined) {
                message("副数不能为空！", "error");
                return false;
            } else if (adjP) {
                message("优惠费用不能大于药品价格的30%！", "error");
                return false;
            } else {
                let removeMedNum = 0;
                this.medicalOrder.orderMedicineList.forEach(mlist => {
                    if (mlist.meStatus !== '0') {
                        removeMedNum++;
                    }
                });
                if (removeMedNum > 0) {
                    message("存在已下架的药材，请处理后重新提交！", "error");
                    return false;
                } else {
                    return true;
                }
            }
        },

        // 多药方工作区：保存当前编辑快照，切换时恢复完整独立状态
        createPrescriptionDraft() {
            return {
                id: Date.now() + Math.random(),
                billingTypeName: '颗粒',
                medicineCount: 0,
                orderPrice: '0.00',
                snapshot: null
            };
        },

        stopMultiPrescriptionSubmitting() {
            if (this.pendingMultiPrescription) {
                this.pendingMultiPrescription = false;
                this.multiPrescriptionSubmitting = false;
            }
        },

        getSharedMedicalOrderSnapshot() {
            const sharedFields = [
                'dppId', 'docId', 'conId', 'serialNo', 'orderKind',
                'mainSuit', 'inspectionRecord', 'clinicalDiagnosis',
                'patientMedicalHistory', 'patientOperationHistory', 'nowMedicalHistory',
                'patientPhone', 'patientName', 'patientSex', 'patientAge', 'patientIdentity'
            ];
            return sharedFields.reduce((result, field) => {
                result[field] = this.medicalOrder[field];
                return result;
            }, {});
        },

        getPrescriptionDraftSnapshot() {
            const medicalOrder = JSON.parse(JSON.stringify(this.medicalOrder));
            const sharedFields = [
                'dppId', 'docId', 'conId', 'serialNo', 'orderKind',
                'mainSuit', 'inspectionRecord', 'clinicalDiagnosis',
                'patientMedicalHistory', 'patientOperationHistory', 'nowMedicalHistory',
                'patientPhone', 'patientName', 'patientSex', 'patientAge', 'patientIdentity'
            ];
            sharedFields.forEach(field => delete medicalOrder[field]);
            return JSON.parse(JSON.stringify({
                medicalOrder,
                docMedicineArray: this.docMedicineArray,
                useAttention: this.useAttention,
                chooseFuliaoList: this.chooseFuliaoList,
                receiveRegion: this.receiveRegion,
                indexMedicine: this.indexMedicine,
                medicineTotle: this.medicineTotle,
                medicineHeavy: this.medicineHeavy,
                medSingleCounPrice: this.medSingleCounPrice,
                orderMedicalCountPrice: this.orderMedicalCountPrice,
                medicineTypeConversionRequestId: this.medicineTypeConversionRequestId,
                chooseFuliao: this.chooseFuliao,
                fuliaoList: this.fuliaoList,
                hadEditAdjustmentPrice: this.hadEditAdjustmentPrice,
                editAdjustmentPrice: this.editAdjustmentPrice,
                preEditAdjustmentPrice: this.preEditAdjustmentPrice,
                dailyFee: this.dailyFee,
                maxFee: this.maxFee,
                feeOptions: this.feeOptions,
                serviceDays: this.serviceDays
            }));
        },

        syncActivePrescriptionSummary() {
            if (!this.prescriptionDrafts.length || this.activePrescriptionIndex < 0) return;
            const draft = this.prescriptionDrafts[this.activePrescriptionIndex];
            if (!draft) return;
            draft.billingTypeName = this.getBillingTypeName(this.medicalOrder.billingType);
            draft.medicineCount = this.docMedicineArray.filter(item => item && item.medicineId).length;
            draft.orderPrice = parseFloat(this.medicalOrder.orderPrice || 0).toFixed(2);
        },

        updateActivePrescriptionDraft() {
            if (!this.prescriptionDrafts.length) return;
            const draft = this.prescriptionDrafts[this.activePrescriptionIndex];
            draft.snapshot = this.getPrescriptionDraftSnapshot();
            draft.billingTypeName = this.getBillingTypeName(this.medicalOrder.billingType);
            draft.medicineCount = this.docMedicineArray.filter(item => item && item.medicineId).length;
            draft.orderPrice = parseFloat(this.medicalOrder.orderPrice || 0).toFixed(2);
        },

        getBillingTypeName(billingType) {
            return {0: '颗粒', 1: '饮片', 2: '膏方', 3: '水丸'}[String(billingType)] || '颗粒';
        },

        restorePrescriptionDraft(index) {
            const draft = this.prescriptionDrafts[index];
            if (!draft || !draft.snapshot) return;
            const state = JSON.parse(JSON.stringify(draft.snapshot));
            const sharedMedicalOrder = this.getSharedMedicalOrderSnapshot();
            this.medicalOrder = {...this.medicalOrder, ...state.medicalOrder, ...sharedMedicalOrder};
            this.docMedicineArray = state.docMedicineArray;
            this.useAttention = state.useAttention;
            this.chooseFuliaoList = state.chooseFuliaoList;
            this.receiveRegion = state.receiveRegion;
            this.indexMedicine = state.indexMedicine;
            this.medicineTotle = state.medicineTotle;
            this.medicineHeavy = state.medicineHeavy;
            this.medSingleCounPrice = state.medSingleCounPrice;
            this.orderMedicalCountPrice = state.orderMedicalCountPrice;
            this.medicineTypeConversionRequestId = state.medicineTypeConversionRequestId;
            this.chooseFuliao = state.chooseFuliao;
            this.fuliaoList = state.fuliaoList;
            this.hadEditAdjustmentPrice = state.hadEditAdjustmentPrice;
            this.editAdjustmentPrice = state.editAdjustmentPrice;
            this.preEditAdjustmentPrice = state.preEditAdjustmentPrice;
            this.dailyFee = state.dailyFee;
            this.maxFee = state.maxFee;
            this.feeOptions = state.feeOptions;
            this.serviceDays = state.serviceDays;
        },

        switchPrescriptionDraft(index) {
            if (index === this.activePrescriptionIndex || this.multiPrescriptionSubmitting) return;
            this.updateActivePrescriptionDraft();
            this.activePrescriptionIndex = index;
            this.restorePrescriptionDraft(index);
            this.changeDeliverWayType();
            this.reCount(false);
        },

        addPrescriptionDraft() {
            if (this.prescriptionDrafts.length >= MAX_PRESCRIPTION_ORDERS) {
                message(`当前最多可添加${MAX_PRESCRIPTION_ORDERS}个药方`, 'warning');
                return;
            }
            this.updateActivePrescriptionDraft();
            this.prescriptionDrafts.push(this.createPrescriptionDraft());
            this.activePrescriptionIndex = this.prescriptionDrafts.length - 1;
            this.resetMedicalOrderFrom(true);
            this.$nextTick(() => this.updateActivePrescriptionDraft());
        },

        removePrescriptionDraft() {
            if (this.prescriptionDrafts.length <= 1 || this.multiPrescriptionSubmitting) return;
            ElMessageBox.confirm(
                `确定删除当前处方吗？删除后，处方内的药材、用法、配送和费用信息将一并移除。`,
                '删除处方确认',
                {
                    confirmButtonText: '确认删除',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal: false
                }
            ).then(() => {
                this.updateActivePrescriptionDraft();
                this.prescriptionDrafts.splice(this.activePrescriptionIndex, 1);
                this.activePrescriptionIndex = Math.max(0, this.activePrescriptionIndex - 1);
                this.restorePrescriptionDraft(this.activePrescriptionIndex);
                this.changeDeliverWayType();
                this.reCount(true);
            }).catch(() => {
                // 取消或关闭确认框，不修改处方草稿。
            });
        },

        // 根据当前处方草稿组装独立订单 payload，不复用其他处方的运行态数据
        buildMultiPrescriptionOrder(index) {
            this.activePrescriptionIndex = index;
            this.restorePrescriptionDraft(index);

            const order = this.medicalOrder;
            order.dppId = this.dppId || this.patientInfo.dppId;
            order.docId = this.doctorInfo && this.doctorInfo.doctorId;
            order.orderKind = '0';
            order.patientPhone = this.patientInfo.phoneNumber;
            order.patientName = this.patientInfo.name || this.searchPatientName;
            order.patientSex = this.patientInfo.sex;
            order.patientAge = this.patientInfo.age;
            order.patientIdentity = this.patientInfo.identity;
            order.orderMedicineList = this.docMedicineArray.map(item => ({
                ...item,
                countNum: item.gCount,
                medicinePrice: item.price
            }));
            order.orderMedicineFuList = this.chooseFuliaoList.map(item => ({
                medicineId: item.medicineId,
                meName: item.meName,
                medicinePrice: item.price,
                countNum: item.meCount,
                meDesc: item.meDesc,
                totalPrice: item.countPrice
            }));

            if (order.billingType === '2') {
                order.takeWay = '1';
            } else if (order.billingType === '3') {
                order.takeWay = '0';
            }
            const takeWayCn = order.takeWay === '0' ? '内服' : '外用';
            if (order.billingType === '0' || order.billingType === '1') {
                order.instructions = `${takeWayCn}。共${order.viceNum}剂，${order.dayTakeNum}日1剂，每日分${order.takeTimes}次服用。`;
            } else if (order.billingType === '2') {
                order.instructions = `每日${order.takeTimes}次，每次${order.timeUseNum}${order.packWay === '0' ? '袋' : 'ml'}。`;
            } else if (order.billingType === '3') {
                order.instructions = `每日${order.takeTimes}次，每次${order.timeUseNum}g`;
            }
            if (order.useWay) order.instructions += `${order.useWay}。`;
            if (order.useAttention) order.instructions += `${order.useAttention}。`;
            if (order.docAdvice) order.instructions += `${order.docAdvice}。`;

            if (!this.chackOrderInfo()) return null;
            for (const item of order.orderMedicineList) {
                if (!item.countNum || item.countNum === 0) {
                    message(`${item.meName}数量不能为0！`, 'error');
                    return null;
                }
            }
            return JSON.parse(JSON.stringify(order));
        },

        // 全部草稿校验通过后才请求服务端；服务端在一个事务内创建全部订单。
        async saveMultiPrescriptionOrders() {
            this.updateActivePrescriptionDraft();
            if (this.prescriptionDrafts.length > MAX_PRESCRIPTION_ORDERS) {
                message(`当前最多可提交${MAX_PRESCRIPTION_ORDERS}个药方`, 'warning');
                this.multiPrescriptionSubmitting = false;
                return;
            }
            const activeIndex = this.activePrescriptionIndex;
            const orders = [];
            try {
                for (let index = 0; index < this.prescriptionDrafts.length; index++) {
                    const draftOrder = this.buildMultiPrescriptionOrder(index);
                    if (!draftOrder) {
                        message(`请先处理处方${index + 1}的问题，全部药方均未提交`, 'error');
                        return;
                    }
                    orders.push(draftOrder);
                }
                this.activePrescriptionIndex = activeIndex;
                this.restorePrescriptionDraft(activeIndex);
                const response = await addClinicPrescriptionBatch(orders);
                if (response.code !== 200) {
                    const error = new Error(response.msg || '多药方提交失败');
                    error.batchRejected = true;
                    throw error;
                }
                const orderIds = response.data;
                this.multiPrescriptionOrderIds = orderIds;
                this.orderId = orderIds[0];
                message(`已成功生成${orderIds.length}个药方订单`, 'success');
                this.refreshAfterMedicalOrderSave();
                this.prescriptionDrafts = [this.createPrescriptionDraft()];
                this.activePrescriptionIndex = 0;
            } catch (error) {
                const serverMessage = error.response && error.response.data && error.response.data.msg;
                const detail = serverMessage || error.message || '多药方提交失败';
                const match = detail.match(/处方(\d+)/);
                if (match && Number(match[1]) <= this.prescriptionDrafts.length) {
                    this.activePrescriptionIndex = Number(match[1]) - 1;
                    this.restorePrescriptionDraft(this.activePrescriptionIndex);
                }
                message(error.batchRejected || serverMessage || (error.response && error.response.status < 500)
                    ? `${detail}；本次药方均未提交，请处理后重试`
                    : `${detail}；提交结果未确认，请先查询订单，避免重复提交`, 'error');
            } finally {
                this.multiPrescriptionSubmitting = false;
            }
        },

        // 提交订单
        saveMedicalOrder() {
            if (this.prescriptionDrafts.length > 1) {
                if (this.multiPrescriptionSubmitting) return;
                this.multiPrescriptionSubmitting = true;
                this.pendingMultiPrescription = true;
                this.pendingCaseOrder = false;
                this.getDocPateintProfileInfo();
                return;
            }
            const medicineList = Array.isArray(this.medicalOrder.orderMedicineList)
                ? this.medicalOrder.orderMedicineList
                : [];
            const hasMedicine = medicineList.some(item => item && (
                item.medicineId !== null && item.medicineId !== undefined && item.medicineId !== ''
            ));

            if (!hasMedicine) {
                ElMessageBox.confirm(
                    '当前未填写药品信息，本次提交将保存为病历工单，不会生成药方订单。是否继续？',
                    '确认提交病历工单',
                    {
                        confirmButtonText: '保存为病历工单',
                        cancelButtonText: '返回修改',
                        type: 'warning',
                        closeOnClickModal: false
                    }
                ).then(() => {
                    this.pendingCaseOrder = true;
                    this.getDocPateintProfileInfo();
                }).catch(() => {
                    // 用户返回修改时不提交任何内容。
                });
                return;
            }

            this.pendingCaseOrder = false;
            this.getDocPateintProfileInfo(); // 先查询患者档案，如果存在则给提示是否覆盖更新
        },

        // 先查询患者档案，如果存在则给提示是否覆盖更新
        getDocPateintProfileInfo() {
            const stopMultiSubmit = () => this.stopMultiPrescriptionSubmitting();
            this.patientInfo.name = this.searchPatientName;
            var mobilePattern = /^1[3456789]\d{9}$/;
            let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            const basicInfoValid = chackAlertMsg(this.patientInfo.name, '患者姓名不能为空', 'error')
                && chackAlertMsg(this.patientInfo.sex, '患者性别不能为空', 'error')
                && chackAlertMsg(this.patientInfo.phoneNumber, '患者联系电话不能为空', 'error')
                && chackAlertMsg(this.patientInfo.identity, '患者身份证不能为空', 'error');
            if (!basicInfoValid) {
                stopMultiSubmit();
                return;
            }
            if (basicInfoValid) {
                if (!mobilePattern.test(this.patientInfo.phoneNumber)) {
                    stopMultiSubmit();
                    message("手机号码格式不正确！", "error")
                } else if (!_IDRe18.test(this.patientInfo.identity) && !_IDre15.test(this.patientInfo.identity)) {
                    stopMultiSubmit();
                    message("身份证号码格式不正确！", "error")
                } else {
                    this.patientQueryParams.identity = this.patientInfo.identity;
                    getPatientList(this.patientQueryParams).then(response => {
                        console.log(response);
                        if (response.data.code === 200) {
                            if (response.data.rows.length > 0) {
                                let patientList = response.data.rows;
                                let hadDiffPatientName = false;
                                let diffPatientName = "";
                                let diffPatientIdentity = "";
                                for (let i = 0; i < patientList.length; i++) {
                                    let patientInfo = patientList[i];
                                    if (patientInfo.name !== this.patientInfo.name) {
                                        hadDiffPatientName = true;
                                        diffPatientName = patientInfo.name;
                                        diffPatientIdentity = patientInfo.identity;
                                        break;
                                    }
                                }
                                if (hadDiffPatientName) {
                                    this.$confirm('系统核查到相同身份证号码的患者信息，但姓名不同：<br/>' +
                                        '<span class="font_red"><i>已存在的姓名：'+diffPatientName+'</i></span><br/>' +
                                        '<span class="font_red"><i>身份证号码：'+diffPatientIdentity+'</i></span><br/>' +
                                        '是否更新患者姓名信息？', '温馨提示', {
                                        confirmButtonText: '更新并继续提交',
                                        cancelButtonText: '暂不更新，核对后再提交',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal: false
                                    }).then(() => {
                                        // 新增或更新患者档案
                                        this.saveDocPateintProfileInfo();
                                    }).catch(() => {
                                        stopMultiSubmit();
                                        this.$message({
                                            type: 'warning',
                                            message: '暂不更新患者姓名，核对后再进行药方提交'
                                        });
                                    });
                                } else {
                                    // 新增或更新患者档案
                                    this.saveDocPateintProfileInfo();
                                }
                            } else {
                                // 新增或更新患者档案
                                this.saveDocPateintProfileInfo();
                            }
                        } else {
                            // 新增或更新患者档案
                            this.saveDocPateintProfileInfo();
                        }
                    }).catch(() => {
                        stopMultiSubmit();
                        message("患者信息查询失败，请稍后重试", "error");
                    })
                }
            }
        },

        // 新增或更新患者档案
        saveDocPateintProfileInfo() {
            // 确保医生ID已正确设置
            if (!this.doctorInfo || !this.doctorInfo.doctorId) {
                this.stopMultiPrescriptionSubmitting();
                message("医生信息未正确加载，请刷新页面重试", "error");
                return;
            }
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.patientInfo.name = this.searchPatientName;
            var mobilePattern = /^1[3456789]\d{9}$/;
            let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            if (chackAlertMsg(this.patientInfo.docId, '患者未正确关联医师', 'error')
                && chackAlertMsg(this.patientInfo.name, '患者姓名不能为空', 'error')
                && chackAlertMsg(this.patientInfo.sex, '患者性别不能为空', 'error')
                && chackAlertMsg(this.patientInfo.phoneNumber, '患者联系电话不能为空', 'error')
                && chackAlertMsg(this.patientInfo.identity, '患者身份证不能为空', 'error')
            ) {
                if (!mobilePattern.test(this.patientInfo.phoneNumber)) {
                    message("手机号码格式不正确！", "error")
                } else if (!_IDRe18.test(this.patientInfo.identity) && !_IDre15.test(this.patientInfo.identity)) {
                    message("身份证号码格式不正确！", "error")
                } else {
                    saveDocPatientProfile(this.patientInfo).then(response => {
                        console.log(response);
                        if (response.code === 200) {
                            this.dppId = response.data;
                            // message("患者基本信息保存成功！", "success");
                            console.log("患者基本信息保存成功!");
                            if (this.pendingCaseOrder) {
                                this.saveCaseOrderInfo();
                            } else {
                                this.saveMedicalOrderInfo(); // 保存开方信息
                            }
                        } else {
                            this.stopMultiPrescriptionSubmitting();
                            message(response.msg, "error");
                        }
                    }).catch(() => {
                        this.stopMultiPrescriptionSubmitting();
                        message("患者档案保存失败，请稍后重试", "error");
                    })
                }
            }
        },


        // 保存开方信息
        saveCaseOrder() {
            this.pendingCaseOrder = true;
            this.getDocPateintProfileInfo();
        },

        saveCaseOrderInfo() {
            this.pendingCaseOrder = false;
            this.medicalOrder.orderKind = '1';
            this.medicalOrder.patientPhone = this.patientInfo.phoneNumber;
            this.medicalOrder.patientName = this.patientInfo.name;
            this.medicalOrder.patientSex = this.patientInfo.sex;
            this.medicalOrder.patientAge = this.patientInfo.age;
            this.medicalOrder.patientIdentity = this.patientInfo.identity;
            this.patientInfo.dppId = this.dppId;
            this.medicalOrder.dppId = this.dppId;
            if (this.medicalOrder.dppId === null || this.medicalOrder.dppId === "" || this.medicalOrder.dppId === undefined) {
                message("关联患者信息为空", "error");
                return false;
            } else if (this.medicalOrder.patientName === null || this.medicalOrder.patientName === "" || this.medicalOrder.patientName === undefined) {
                message("请输入患者姓名", "error");
                return false;
            } else if (this.medicalOrder.patientSex == null || this.medicalOrder.patientSex === "" || this.medicalOrder.patientSex === undefined) {
                message("请选择患者性别", "error");
                return false;
            } else if (this.medicalOrder.clinicalDiagnosis == null || this.medicalOrder.clinicalDiagnosis === "" || this.medicalOrder.clinicalDiagnosis === undefined) {
                message("诊断信息不能为空", "error");
                return false;
            }
            this.medicalOrder.orderMedicineList = [];
            this.medicalOrder.orderMedicineFuList = [];
            this.medicalOrder.orderPrice = "0.00";
            this.medicalOrder.medicalCountPrice = "0.00";
            this.medicalOrder.fuCountPrice = 0;
            this.medicalOrder.docPrice = "0.00";
            this.medicalOrder.adjustmentPrice = "0.00";
            this.medicalOrder.discountPrice = "0.00";
            this.medicalOrder.processingCosts = "0.00";
            this.medicalOrder.viceNum = 0;
            this.medicalOrder.orderWeight = "0";
            if (this.isEditOrder) {
                this.saveEditMedicalOrderForDoc();
            } else {
                this.addMedicalOrderForDoc();
            }
        },

        saveMedicalOrderInfo() {
            if (this.pendingMultiPrescription) {
                this.pendingMultiPrescription = false;
                this.saveMultiPrescriptionOrders();
                return;
            }
            if (this.chackOrderInfo()) {
                let f = true;
                // 修复：使用for循环替代forEach，以便正确终止并阻止提交
                for (let i = 0; i < this.medicalOrder.orderMedicineList.length; i++) {
                    const item = this.medicalOrder.orderMedicineList[i];
                    item.countNum = item.gCount;
                    item.medicinePrice = item.price;

                    if (!item.countNum || item.countNum === 0 || item.countNum === "" || item.countNum === null) {
                        message(item.meName + "数量不能为0！", "error");
                        f = false;
                        break; // 终止循环
                    }
                }

                if (!f) {
                    return false; // 修复：如果校验失败，阻止继续提交
                }

                this.medicalOrder.orderMedicineFuList = [];
                if (this.medicalOrder.billingType === '2') {
                    this.chooseFuliaoList.forEach((meFulist) => {
                        this.medicalOrder.orderMedicineFuList.push({
                            medicineId: meFulist.medicineId,
                            meName: meFulist.meName,
                            medicinePrice: meFulist.price,
                            countNum: meFulist.meCount,
                            meDesc: meFulist.meDesc,
                            totalPrice: meFulist.countPrice,
                        })
                    })
                    this.medicalOrder.takeWay = '1';
                } else if (this.medicalOrder.billingType === '3') {
                    this.medicalOrder.takeWay = '0';
                }

                console.log(this.medicalOrder)
                let takeWayCn = "";
                if ('0' === this.medicalOrder.takeWay) {
                    takeWayCn = "内服";
                } else {
                    takeWayCn = "外用";
                }

                if (this.medicalOrder.billingType === '0' || this.medicalOrder.billingType === '1') {
                    this.medicalOrder.instructions = takeWayCn + "。" + "共" + this.medicalOrder.viceNum + "剂，" +
                        this.medicalOrder.dayTakeNum + "日1剂，每日分" + this.medicalOrder.takeTimes + "次服用。";
                } else if (this.medicalOrder.billingType === '2') {
                    this.medicalOrder.instructions = "每日" + this.medicalOrder.takeTimes + "次，每次" + this.medicalOrder.timeUseNum;
                    if (this.medicalOrder.packWay === '0') {
                        this.medicalOrder.instructions += "袋。";
                    } else if (this.medicalOrder.packWay === '1') {
                        this.medicalOrder.instructions += "ml。";
                    }
                } else if (this.medicalOrder.billingType === '3') {
                    this.medicalOrder.instructions = "每日" + this.medicalOrder.takeTimes + "次，每次" + this.medicalOrder.timeUseNum + "g";
                }

                if (this.medicalOrder.useWay !== '' && this.medicalOrder.useWay !== null && this.medicalOrder.useWay !== undefined) {
                    this.medicalOrder.instructions += this.medicalOrder.useWay + "。";
                }

                if (this.medicalOrder.useAttention !== '' && this.medicalOrder.useAttention !== null && this.medicalOrder.useAttention !== undefined) {
                    this.medicalOrder.instructions += this.medicalOrder.useAttention + "。";
                }

                if (this.medicalOrder.docAdvice !== '' && this.medicalOrder.docAdvice !== null && this.medicalOrder.docAdvice !== undefined) {
                    this.medicalOrder.instructions += this.medicalOrder.docAdvice + "。";
                }
                console.log(this.medicalOrder.isFree);
                if (!f) {
                    return false;
                }

                if (this.isEditOrder) {
                    this.saveEditMedicalOrderForDoc();
                } else {
                    this.addMedicalOrderForDoc();
                }
            }
        },

        // 保存工单信息
        addMedicalOrderForDoc() {
            let that = this;
            const isCaseOrder = this.medicalOrder.orderKind === '1';
            if (this.isOneMoreOrder) {
                //onload 时加载的oldOrderId 会被冲掉
                if (this.again !== "" && this.again !== null && this.again !== undefined) {
                    if (this.again === "0") {
                        this.medicalOrder.oldOrderId = this.orderId;
                    } else {
                        this.medicalOrder.oldOrderId = "";
                    }
                }
                message("药方生成中，请稍后……");
                that.loading = true;
                addFromDocClinic(this.medicalOrder).then(response => {
                    that.loading = false;
                    if (response.code === 200) {
                        // 保存成功后保留当前患者，清空药方并刷新病历列表
                        this.refreshAfterMedicalOrderSave();
                        window.sessionStorage.removeItem('medicineList');
                        window.sessionStorage.removeItem("patient_" + this.patientInfo.dppId);
                        // 修复：重置订单状态标志，避免下次操作时状态混乱
                        this.isOneMoreOrder = false;
                        this.isEditOrder = false;
                        this.orderId = response.data;
                        if (isCaseOrder) {
                            message("病例单保存成功", "success");
                            return;
                        }
                        ElMessageBox.confirm("提交成功!请患者查收短信完成支付", "温馨提示", {
                            confirmButtonText: '确定',
                            type: 'success',
                        }).then(() => {
                            this.$router.push({path: '/admin/detail', query: {orderId: this.orderId}});
                            this.$store.state.adminleftnavnum = 'detail'; //设置左侧导航2-2 active
                        }).catch(cancel => {
                            console.log(cancel)
                        })
                    } else {
                        alertMsg(response.msg, "error");
                    }
                });
            } else {
                message("药方生成中，请稍后……");
                that.loading = true;
                console.log('this.medicalOrder', this.medicalOrder)
                addFromDocClinic(this.medicalOrder).then(response => {
                    that.loading = false;
                    if (response.code === 200) {
                        // 保存成功后保留当前患者，清空药方并刷新病历列表
                        this.refreshAfterMedicalOrderSave();
                        window.sessionStorage.removeItem('medicineList');
                        window.sessionStorage.removeItem("patient_" + this.patientInfo.dppId);
                        // 修复：重置订单状态标志
                        this.isOneMoreOrder = false;
                        this.isEditOrder = false;
                        this.orderId = response.data;
                        console.log(this.orderId);
                        if (isCaseOrder) {
                            message("病例单保存成功", "success");
                            return;
                        }
                        ElMessageBox.confirm("提交成功!请患者查收短信完成支付", "温馨提示", {
                            confirmButtonText: '查看详情',
                            cancelButtonText: '立即收费',
                            type: 'success',
                        }).then(() => {
                            this.$router.push({path: '/admin/detail', query: {orderId: this.orderId}});
                            this.$store.state.adminleftnavnum = 'detail'; //设置左侧导航2-2 active
                        }).catch(() => {
                            this.openPayScreen(this.orderId);
                        })
                    } else {
                        alertMsg(response.msg, "error");
                    }
                });
            }
        },


        // 保存编辑后的工单信息
        saveEditMedicalOrderForDoc() {
            let that = this;
            const isCaseOrder = this.medicalOrder.orderKind === '1';
            const currentOrderId = this.medicalOrder.orderId;
            message("药方信息保存中，请稍后……");
            that.loading = true;
            console.log('this.medicalOrder', this.medicalOrder)
            updateMedicalOrderForDoc(this.medicalOrder).then(response => {
                that.loading = false;
                if (response.code === 200) {
                    // 保存成功后保留当前患者，清空药方并刷新病历列表
                    this.refreshAfterMedicalOrderSave();
                    window.sessionStorage.removeItem('medicineList');
                    window.sessionStorage.removeItem("patient_" + this.patientInfo.dppId);
                    // 修复：重置订单状态标志
                    this.isOneMoreOrder = false;
                    this.isEditOrder = false;
                    this.orderId = currentOrderId;
                    if (isCaseOrder) {
                        message("病例单保存成功", "success");
                        return;
                    }
                    ElMessageBox.confirm("药方提交成功!请患者查收短信完成支付", "温馨提示", {
                        confirmButtonText: '查看详情',
                        cancelButtonText: '暂不查看',
                        type: 'success',
                    }).then(() => {
                        this.$router.push({path: '/admin/detail', query: {orderId: this.orderId}});
                        this.$store.state.adminleftnavnum = 'detail'; //设置左侧导航2-2 active
                    }).catch(cancel => {
                        console.log(cancel)
                    })
                } else {
                    alertMsg(response.msg, "error");
                }
            });
        },


        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
